import React from 'react'
import { useNavigate,useParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
	CHeader,CHeaderBrand,CHeaderNav,CHeaderToggler,
	CFooter,
	CRow,
	CCol,
	CContainer,
	CForm,
	CFormInput,
	CFormTextarea,
	CFormCheck,
	CFormSelect,
	CButton,
	CInputGroup,
	CInputGroupText,
	CCard,
	CCardHeader,
	CCardBody,
	CCardFooter,
	CImage,
	CLink,
	CTooltip,
	CSpinner,
	CBadge,
	CModal,CModalHeader,CModalTitle,CModalBody,CModalFooter,CCloseButton,
	CListGroup,CListGroupItem,
	CDropdown,CDropdownToggle,CDropdownMenu,CDropdownItem
} from '@coreui/react';
import CIcon from '@coreui/icons-react'
import {
	MyButton,
	MyHeaderProfile,
	MyDialogform,
	MyDialoglookup,
	MyDialogview,
	MySessionextender,
	MyDialogperawat,
	MyDialogodontogram,
} from '../../components/index'
import NumberFormat from 'react-number-format';
import { isMobile } from "react-device-detect";
import { Konfirm } from '../../helpers/onConfirm'
import { UFunc } from '../../helpers/functions'

const pjson 	= require('../../../package.json')
const Periksa = (props) => {
	const {
		setLoading,showToast,prosesExpired,setSessionaktif
	} = props;
	const { tabel_id } 				= useParams(); 

	//--DOM--/
	const uNavigate 				= useNavigate();
	const uDispatch 				= useDispatch();
	//--END DOM--/

	const uPasienID 				= parseInt(tabel_id || "0")
	const uBahasaObj  				= useSelector(state => state.listBahasa);
	const uActiveroute  			= useSelector(state => state.activeRoute);
	const uUsersettingObj 			= useSelector(state => state.gListUserSetting);
	const uSystemsettingObj			= useSelector(state => state.gSystemsetting);
	const uIsScrollBottom			= useSelector(state => state.gIsScrollBottom);
	const uEfekapp					= useSelector(state => state.effectApp);
	const uUrlbefore 				= useSelector(state => state.gUrlbefore);

	const [uEfekview,setEfekview] 	= React.useState(false);
	const [uEfekview2,setEfekview2] = React.useState(false);
	const uMaxData					= isMobile ? (uUsersettingObj.jml_mobile || 10) : (uUsersettingObj.jml_laporan || 100);
	const uTokenObj					= JSON.parse(localStorage.getItem("token")||"{}");
	const uIsHapusallow				= (uTokenObj.userhak==="FREEROLE"||uTokenObj.userhak==="ADMIN") ? true : false;
	const [uHtml500msg,setHtml500msg]	= React.useState(); 
	const [uTimeelapse,setTimeelapse]	= React.useState(0); 

	const [uDatamainObj,setDatamainObj]	= React.useState(useSelector(state => state.gBillingperiksaObj) || {});
	const uItemsArr						= uDatamainObj.items_arr || [];
	//const uJanjianArr					= uDatamainObj.janjian_arr || [];
	const uPerawatArr					= uDatamainObj.perawat_arr || [];
	const [uTambahitemObj,setTambahitemObj]	= React.useState({})
	const [uTabelitemObj,setTabelitemObj]	= React.useState({})
	const uFototambahArr			= uDatamainObj.foto_arr || [];// useSelector(state => state.gFototambahArr) || [];
	const [uUpdatefield,setUpdatefield] 	= React.useState(false);

	const uDatacabangArr					= JSON.parse(localStorage.getItem("cabanglist")||"[]")
	const [uDatapasienObj,setDatapasienObj]	= React.useState({})
	const [uDatadokterArr,setDatadokterArr]	= React.useState([])
	const [uDataanamnaseArr,setDataanamnaseArr]	= React.useState([])
	const [uDataperawatArr,setDataperawatArr]	= React.useState([]);//-->TIDAK_DIPAKAI--/
	const [uDatacatdokterArr,setDatacatdokterArr]= React.useState([])
	const [uDatadiagnosaArr,setDatadiagnosaArr]= React.useState([])
	const [uDataterapiArr,setDataterapiArr]	= React.useState([])
	const [uDatajanjianArr,setDatajanjianArr]= React.useState([])
	const [uDataitemcicilanArr,setDataitemcicilanArr]= React.useState([])
	const [uHeaderloading,setHeaderloading]	= React.useState(false)
	const [uIsFormupdate,setIsFormupdate]	= React.useState(false)
	const uCabanginitObj 					= useSelector(state => state.gCabangatribut) || {};

	//---DLG_LOOKUP--/
	const [uIsDlglookupshow,setDlglookupshow]	= React.useState(false)
	const [uDlglookupheader,setDlglookupheader]	= React.useState("")
	const [uInpDlglookup,setInpDlglookup]	= React.useState("")
	const [uDataDlglookupArr,setDataDlglookupArr]= React.useState([])
	const [uDlglookupjenis,setDlglookupjenis]	= React.useState("")
	//---END DLG_LOOKUP--/

	//---DLG_VIEW--/
	const [uIsDlgviewshow,setDlgviewshow]		= React.useState(false)
	const [uDlgviewheader,setDlgviewheader]		= React.useState("")
	const [uDlgviewjenis,setDlgviewjenis]		= React.useState("")
	//---END DLG_VIEW--/

	//--DLG_FORM--/
	const [uDlgformheader,setDlgformheader]		= React.useState("")
	const [uIsDlgformshow,setDlgformshow]		= React.useState(false)
	const [uDlgformdataObj,setDlgformdataObj]	= React.useState({})
	//--END DLG_FORM--/

	//--DLG_FORMPERAWAT--/
	const [uISDlgperawatshow,setDlgperawatshow]		= React.useState(false)
	const [uDlgperawatdataObj,setDlgperawatdataObj]	= React.useState({})
	const uPerawatselectingArr 				= JSON.parse(useSelector(state => state.perawat_selecting_str) || "[]");
	//--END DLG_FORMPERAWAT--/

	//--DLG_ODONTOGRAM--/
	const [uISDlgodontogramshow,setDlgodontogramshow]	= React.useState(false)
	const [uDlgodontogramdataObj,setDlgodontogramdataObj]= React.useState({})
	const uOdontogramprocessingArr 			= JSON.parse(useSelector(state => state.gigi_processing_str) || "[]");
	//--END DLG_ODONTOGRAM--/

	//--DLG_ODONTOGRAM--/
	const [uISDlgterapishow,setDlgterapishow]	= React.useState(false)
	const [uDlgterapiObj,setDlgterapiObj]		= React.useState({})
	//--END DLG_ODONTOGRAM--/

	//--DOM--/
	const uWindowwidth			= window.outerWidth;
	const uISTabletview			= uWindowwidth > 425 && uWindowwidth <= 768;
	const uISCellphoneview		= uWindowwidth <= 425;
	//--END DOM--*/

	//---HANDEL--/
	const hdlKDownDocument = (_EV) => {
		/*if(_EV.keyCode === 27) {
			if(uCekantrianshow) {
				_EV.preventDefault();
				_EV.stopPropagation();

				setCekantrianshow(false);
			}
			return;
		}//-*/
		if(_EV.keyCode === 120) {
			const vElsimpan = document.getElementById("btnSimpanmain");
			vElsimpan && (vElsimpan.click())
			return;
		}
	}
	const hdlKlikBack = () => {
		uNavigate("/subpasien/pasien/rekammedis/"+uPasienID,{replace:true}); return;
	}
	const hdlKlikReset = async() => {
		const vResetawal = () => {
			setTambahitemObj({})
			setTabelitemObj({})
			apiLoadawal()
		}

		if(uIsFormupdate) {
			if(await(Konfirm(
				"<b>Billing Periksa Akan DIRESET..</b>"+
				"<br/>Form Billing Kemungkinan Sudah ADA Perubahan Field Data. "+
					"Anda Belum Menyimpannya, dan dapat membatalkan Perubahan Tersebut !"+
				"<br/><br/>Apakah Anda Yakin ?"+
				""))) initResetmain();
		} else {
			vResetawal();
		}
	}
	const hdlToggleDlgLookup = () => { setDlglookupshow(false)}
	const hdlKlikDlglookuppilih = (_IDITEM) => {
		_IDITEM = parseInt(_IDITEM)||0; if(_IDITEM <= 0) return;

		if(uDlglookupjenis==="DOKTER")
			lookupPilihdokter(_IDITEM);
		//else if(uDlglookupjenis==="DOKTERJANJIAN") lookupPilihdokterjanjian(_IDITEM);
		else if(uDlglookupjenis==="ANAMNASE")
			lookupPilihanamnase(_IDITEM);
		else if(uDlglookupjenis==="CATDOKTER")
			lookupPilihcatdokter(_IDITEM);
		/*else if(uDlglookupjenis==="TERAPI")//--TIDAK_DIPAKAI--/
			lookupPilihterapi(_IDITEM)//-*/
		else if(uDlglookupjenis==="DIAGNOSA")
			lookupPilihdiagnosa(_IDITEM);
		else if(uDlglookupjenis==="DIAGNOSAFORM")
			lookupPilihFormdiagnosa(_IDITEM);
		/*else if(uDlglookupjenis==="FORMTERAPI")//--MOBILE_TIDAK_DIPAKAI
			lookupFormterapi(_IDITEM);//-*/

		hdlToggleDlgLookup();
	}
	const hdlToggleDlgform = () => { setDlgformshow(false); }
	const hdlKlikDlgformsimpan = () => {
		/*if(uDlgformdataObj.jenis === "JANJIAN") {
			initKlikformjanjian(); return;
		}//-*/
		if(uDlgformdataObj.jenis === "FORMTERAPI") {
			initKlikformitem(); return;
		}
	}
	const hdlToggleDlgview = () => { setDlgviewshow(false)}

	const hdlKlikDokterlookup = () => {
		setInpDlglookup("");
		setDlglookupjenis("DOKTER");

		const vTmpArr	= uDatadokterArr.map(vItems => {
			return {id:vItems.id,caption:vItems.dokter_caption}});
		setDataDlglookupArr(vTmpArr);
		setDlglookupheader("Pilih: NAMA DOKTER");
		setDlglookupshow(true);
	}
	const hdlKlikAnamnaselookup = () => {
		setInpDlglookup("");
		setDlglookupjenis("ANAMNASE");

		const vTmpArr	= uDataanamnaseArr.map(vItems => {
			return {id:vItems.id,caption:vItems.anamnase_caption}});
		setDataDlglookupArr(vTmpArr);
		setDlglookupheader("Pilih: ANAMNASE");
		setDlglookupshow(true);
	}
	const hdlKlikPerawat = () => {
		setDlgperawatdataObj({
			selected_arr: uDatamainObj.perawat_arr || [],
		})
		setDlgperawatshow(true);

		//--LAMA--/
		return;
		setDlgviewjenis("PERAWAT");
		setDlgviewheader("Pilih NAMA PERAWAT");
		setDlgviewshow(true);
		//--END LAMA--/
	}
	const hdlChangePerawatcheck = (e) => {//--TIDAK_DIPAKAI--/
		const vValueID	= parseInt(e.target.value)||0;

		const vArridx = UFunc.getObjectIndeks(uPerawatArr,vValueID);
		//console.log("(Periksa - hdlChangePerawatcheck) vArridx => "+vArridx)
		if(vArridx < 0) {
			const vTmpArr = (uDataperawatArr.filter(vItems=>
				(vItems.id||"0").toString() === vValueID.toString()));

			//console.log("(Periksa - hdlChangePerawatcheck) vArridx => "+JSON.stringify(vTmpArr))
			uDatamainObj.perawat_arr = [...uPerawatArr,vTmpArr[0]];
		} else {
			uPerawatArr.splice(vArridx,1);
			uDatamainObj.perawat_arr = uPerawatArr;
		}
		setUpdatefield(!uUpdatefield);
	}
	const hdlKlikPerawatclear = async() => {
		if(uPerawatArr.length <= 0) return;

		if(await(Konfirm("Apakah Yakin Akan Menghapus SELURUH Perawat ?"))) {
			uDatamainObj.perawat_arr = [];
			setUpdatefield(!uUpdatefield);
		}
 	}
	const hdlKlikCatdokterlookup = () => {
		setInpDlglookup("");
		setDlglookupjenis("CATDOKTER");

		const vTmpArr	= uDatacatdokterArr.map(vItems => {
			return {id:vItems.id,caption:vItems.note_caption}});
		setDataDlglookupArr(vTmpArr);
		setDlglookupheader("Pilih: CATATAN DOKTER");
		setDlglookupshow(true);
	}
	const hdlKDownTerapicaption = (_EV) => {//--TIDAK_DIPAKAI--/
		initResettambahform();
		if(_EV.keyCode !== 13) return;
		const vTerapicaption	= (uTambahitemObj.terapi_caption||"").trim();
		if(vTerapicaption === "") return;

		_EV.preventDefault()
		_EV.stopPropagation();

		const vArrCariMaster 	= uDataterapiArr.filter((vItem)=>
			vItem.terapi_caption.toUpperCase().includes((vTerapicaption).toUpperCase()));
		
		if (vArrCariMaster.length === 1) {
			uTambahitemObj.id				= (vArrCariMaster[0].id);
			uTambahitemObj.terapi_caption	= (vArrCariMaster[0].terapi_caption);
			uTambahitemObj.terapi_tarif		= parseInt(vArrCariMaster[0].terapi_tarif || 0);
			uTambahitemObj.terapi_main		= (vArrCariMaster[0].terapi_main);
			uTambahitemObj.status_garansi 	= vArrCariMaster[0].status_garansi;
			uTambahitemObj.terapi_qty		= 1;

			setEfekview(!uEfekview);
			const vElfocus = document.getElementById("inptambahitemqty");
			vElfocus && vElfocus.focus();
			return;
		}

		hdlKlikTerapilookup();
	}
	const hdlKlikTerapilookup = () => {
		//--CEK_IDDOKTER--/
		const vDokteridx = UFunc.getObjectIndeks(uDatadokterArr,uDatamainObj.id_dokter);
		if(vDokteridx < 0) {
			document.getElementById("inpdoktercaption") &&
				document.getElementById("inpdoktercaption").focus();

			showToast("Nama Dokter Harus Dipilih Terlebih Dahulu !"); return;
		}
		const vArrkompetensiID = uDatadokterArr[vDokteridx].kompetensi_arr || [];
		//--END CEK_IDDOKTER--/

		const vTmpArr	= uDataterapiArr.filter(vItems =>{
			return (parseInt(vItems.id_kompetensi||0) <= 0 ||
				vArrkompetensiID.includes(vItems.id_kompetensi.toString())
			);
		}).map(vItems => {
			const vSort = UFunc.getObjectIndeks((uTambahitemObj.terapi_arr||[]),vItems.id) >= 0 ? 1 : 0;
			return {
				id:vItems.id,
				caption:vItems.terapi_caption,// +" ("+vItems.id_kompetensi+")",
				harga_satuan:vItems.terapi_tarif,
				sort: vSort,
			}
		});
		setDlgterapiObj({
			selecting_arr: (uTambahitemObj.terapi_arr||[]),
			data_arr: vTmpArr,
		});
		setDlgterapishow(true);

		//--TIDAK_DIPAKAI--/
		return;
		setInpDlglookup(uTambahitemObj.terapi_caption||"");
		setDlglookupjenis("TERAPI");
		//console.log("(hdlKlikTerapilookup) vTmpArr => "+JSON.stringify(vTmpArr));
		setDataDlglookupArr(vTmpArr);
		setDlglookupheader("Pilih: TERAPI");
		setDlglookupshow(true);
		//--END TIDAK_DIPAKAI--/
	}
	const hdlKlikDiagnosalookup = (_IDXITEM) => {
		_IDXITEM = _IDXITEM===undefined ? -1 : parseInt(_IDXITEM);
		if(_IDXITEM < 0) { setTabelitemObj({}) }

		setInpDlglookup("");
		setDlglookupjenis("DIAGNOSA");

		const vTmpArr	= uDatadiagnosaArr.map(vItems => {
			return {id:vItems.id,caption:vItems.nama_diagnosa}});
		setDataDlglookupArr(vTmpArr);
		setDlglookupheader("Pilih: DIAGNOSA");
		setDlglookupshow(true);
	}
	const hdlKlikKetgigi = (_IDXITEM) => {
		_IDXITEM = _IDXITEM===undefined ? -1 : parseInt(_IDXITEM);
		const vISFormitem 	= (uDlgformdataObj.jenis === "FORMTERAPI");

		let vOdontogramArr = []
		if(!vISFormitem) {
			if(_IDXITEM < 0) { 
				setTabelitemObj({}) 
				vOdontogramArr	= (uTambahitemObj || {}).odontogram_arr || [];
			} else {
				vOdontogramArr	= (uTabelitemObj || {}).odontogram_arr || [];
			}
		} else {
			vOdontogramArr	= (uDlgformdataObj || {}).odontogram_arr || [];
		}

		setDlgodontogramdataObj({
			selected_arr: vOdontogramArr,
		});
		setDlgodontogramshow(true);
	}
	const hdlKlikDlgodontogramsimpan = () => {
		//--VALIDASI_JIKA_SAMA--/
		//--END VALIDASI_JIKA_SAMA--/

		const vISFormitem 	= (uDlgformdataObj.jenis === "FORMTERAPI");

		const vKetgigi 	= uOdontogramprocessingArr.
			filter(vItems=>(vItems.status_hapus||"TIDAK")!=="YA").
			map(vItems=>{
			return vItems.nomor_gigi==="ALL" ? "SEMUA GIGI": "No-"+vItems.nomor_gigi;
		}).join(", ");

		//console.log("(Periksa - hdlKlikDlgodontogramsimpan) uDlgformdataObj.jenis",uDlgformdataObj.jenis);
		//console.log("(Periksa - hdlKlikDlgodontogramsimpan) uTabelitemObj",uTabelitemObj);
		//console.log("(Periksa - hdlKlikDlgodontogramsimpan) uOdontogramprocessingArr",uOdontogramprocessingArr);
		if(!vISFormitem) {
			if(JSON.stringify(uTabelitemObj||{})==="{}") {
				setTambahitemObj({...uTambahitemObj,
					ketgigi: vKetgigi,
					odontogram_arr: uOdontogramprocessingArr || [], 
				})
			} else {
				setTabelitemObj({...uTabelitemObj,
					keterangan: vKetgigi,
					odontogram_arr: uOdontogramprocessingArr || [], 
				})
			}
		} else {
			setDlgformdataObj({...uDlgformdataObj,
				ketgigi: vKetgigi,
				odontogram_arr: uOdontogramprocessingArr || [], 
			})
		}
		setDlgodontogramshow(false); 
	}
	const hdlKlikketgigiview = (_IDXITEM) => {//--TIDAK_DIPAKAI--/
		_IDXITEM = _IDXITEM===undefined ? -1 : parseInt(_IDXITEM);

		if(_IDXITEM < 0) { setTabelitemObj({}) }

		setDlgviewjenis("KETGIGI");
		setDlgviewheader("Pilih NOMOR GIGI");
		setDlgviewshow(true);
	}
	const hdlKlikPilihketgigi = (_EV,_TEKSVALUE) => {//--TIDAK_DIPAKAI--/
		_TEKSVALUE		= (_TEKSVALUE||"").trim();
		const vElcheck		= document.getElementById("iddiagramchecked");
		const vISFormitem 	= (uDlgformdataObj.jenis === "FORMTERAPI");

		//console.log("(hdlKlikPilihketgigi) uDlgformdataObj.jenis => "+uDlgformdataObj.jenis);
		//console.log("(hdlKlikPilihketgigi) vISFormitem => "+vISFormitem);

		if(vISFormitem) {
			uDlgformdataObj.ketgigi = ((uDlgformdataObj.ketgigi||"").trim() === "" ? ""
				: uDlgformdataObj.ketgigi+", ")+ _TEKSVALUE;
		} else {
			if(JSON.stringify(uTabelitemObj||{})==="{}") {
				uTambahitemObj.ketgigi = (uTambahitemObj.ketgigi||"") +
					((uTambahitemObj.ketgigi||"").trim()!=="" ? ", " : "")+
					_TEKSVALUE; 
			} else {
				uTabelitemObj.keterangan = (uTabelitemObj.keterangan||"") +
					((uTabelitemObj.keterangan||"").trim()!=="" ? ", " : "")+
					_TEKSVALUE; 
			}
		}
		setEfekview(!uEfekview);

		if(vElcheck) {
			vElcheck.style.top 	= (_EV.clientY - _EV.target.offsetTop - 18)+"px";
			vElcheck.style.left = (_EV.clientX - _EV.target.offsetLeft + 7)+"px";
			vElcheck.style.display = "block";
			//alert(_EV.pageX);
		}

		let vTimeout = setTimeout((e) => {
			clearTimeout(vTimeout);
			vElcheck && (vElcheck.style.display = "none");
		},700);//--*/
	}
	const hdlChangeDlgterapicheck = (_EV) => {
		const vValueID	= parseInt(_EV.target.value)||0;
		if(vValueID <= 0) return;

		if(_EV.target.checked) {
			const vArridx	= UFunc.getObjectIndeks(uDataterapiArr,vValueID);
			setDlgterapiObj({...uDlgterapiObj,
				selecting_arr : [...(uDlgterapiObj.selecting_arr||[]),
					{...(uDataterapiArr[vArridx]||{}),sort:1},
				]
			})
		} else {
			const vSelectingIdx	= UFunc.getObjectIndeks((uDlgterapiObj.selecting_arr || []),vValueID);
			(uDlgterapiObj.selecting_arr || []).splice(vSelectingIdx,1);
			setEfekview(!uEfekview);
		}
	}
	const hdlKlikDlgterapisimpan = () => {
		const vISFormitem 	= (uDlgformdataObj.jenis === "FORMTERAPI");

		if(vISFormitem) {
			if((uDlgterapiObj.selecting_arr||[]).length <= 0) {
				setDlgformdataObj({...uDlgformdataObj,
					terapi_caption: "",
					terapi_arr: [],
				});
				setDlgterapishow(false);
				return;
			}
			
			setDlgformdataObj({...uDlgformdataObj,
				terapi_caption: (uDlgterapiObj.selecting_arr || []).map(vItems=>{
					return vItems.terapi_caption;

					const vArrcaption = (vItems.terapi_caption||"").split(" ");

					return vArrcaption.length > 3 
						? UFunc.Usercaptionfilter(vItems.terapi_caption,3)+"..."
						: vItems.terapi_caption;
				}).join("; "),
				terapi_arr: uDlgterapiObj.selecting_arr || [],
				terapi_qty: 1,
			});
			setDlgterapishow(false);

			let vTimeout = setTimeout(()=>{
				clearTimeout(vTimeout)
				const vElfocus = document.getElementById("inpformitemqty");
				vElfocus && vElfocus.focus()
			},350)

			return;
		}

		if((uDlgterapiObj.selecting_arr||[]).length <= 0) {
			setTambahitemObj({...uTambahitemObj,
				terapi_caption: "",
				terapi_arr: [],
			});
			setDlgterapishow(false);
			return;
		}
			
		setTambahitemObj({...uTambahitemObj,
			terapi_caption: (uDlgterapiObj.selecting_arr || []).map(vItems=>{
				return vItems.terapi_caption;

				const vArrcaption = (vItems.terapi_caption||"").split(" ");

				return vArrcaption.length > 3 
					? UFunc.Usercaptionfilter(vItems.terapi_caption,3)+"..."
					: vItems.terapi_caption;
			}).join("; "),
			terapi_arr: uDlgterapiObj.selecting_arr || [],
			terapi_qty: 1,
		});
		setDlgterapishow(false);

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout)
			const vElfocus = document.getElementById("inptambahitemqty");
			vElfocus && vElfocus.focus()
		},350)
	}
	const hdlKlikTambahitem = () => {
		if((uTambahitemObj.terapi_arr || []).length <= 0) return;

		//alert(JSON.stringify((uTambahitemObj.terapi_arr || []))); return;

		if(parseInt(uTambahitemObj.terapi_qty||0) < 1) {
			document.getElementById("inptambahitemqty") &&
				document.getElementById("inptambahitemqty").focus();
			return;
		}

		if((parseInt(uDatapasienObj.max_terapi)||0) > 0)
			if(uItemsArr.length >= (parseInt(uDatapasienObj.max_terapi)||0)) {
				showToast("Maaf,"+
					"<br/>Jumlah Terapi Sudah <b>Mencapai Batas Ketentuan Asuransi</b>, yaitu "+uDatapasienObj.max_terapi+" Terapi.."+
					""); return;
			}

		let vTerapimain;
		const vArrterapitambah	= (uTambahitemObj.terapi_arr || []).map(vItems=>{
			vTerapimain = vTerapimain=== "" ? (vItems.terapi_main || "") : vTerapimain;

			const vTmpObj = {
				id_terapi_sub : parseInt(vItems.id)||0,
				caption_terapi : vItems.terapi_caption || "",
				tarif_terapi: parseFloat(vItems.terapi_tarif) || 0,
				qty_terapi: parseInt(uTambahitemObj.terapi_qty) || 1,
				diagnosa_id : uTambahitemObj.diagnosa_id||0,
				diagnosa_caption : (uTambahitemObj.diagnosa_caption||"").trim(),
				diagnosa_keterangan : (uTambahitemObj.diagnosa_keterangan||"").trim(),
				tindakan : UFunc.nl2br((uTambahitemObj.tindakan||"").trim()),
				keterangan : (uTambahitemObj.ketgigi||"").trim(),
				odontogram_arr: (uTambahitemObj.odontogram_arr || []),
				status_ada_garansi : (uTambahitemObj.status_garansi||"TIDAK"),
				tgl_batas_garansi : "",
			}

			return vTmpObj;
		});

		setDatamainObj({...uDatamainObj,
			items_arr: [...vArrterapitambah,...uItemsArr],
		})
		const vTmpresetObj = {
			terapi_caption : vTerapimain
		}
		setTambahitemObj(vTmpresetObj);

		document.getElementById("inptambahitemdiagnosa") &&
			document.getElementById("inptambahitemdiagnosa").focus();
		//setUpdatefield(!uUpdatefield);
	}
	const hdlKlikTabelsimpan = (_IDXITEM) => {
		_IDXITEM = parseInt(_IDXITEM); if(_IDXITEM < 0) return;

		if(parseInt(uTabelitemObj.qty_terapi||0) < 1) {
			document.getElementById("inptabelitemqty") &&
				document.getElementById("inptabelitemqty").focus();
			return;
		}
		const vTabelidx	= uTabelitemObj.tabelidx;

		//console.log("(Periksa - hdlKlikTabelsimpan) _IDXITEM",_IDXITEM);
		//console.log("(Periksa - hdlKlikTabelsimpan) vTabelidx",vTabelidx);
		//console.log("(Periksa - hdlKlikTabelsimpan) uTabelitemObj",uTabelitemObj);
		//console.log("(Periksa - hdlKlikTabelsimpan) uItemsArr[vTabelidx]",uItemsArr[vTabelidx]);
		
		//---PROSES_EDIT--/
		/*uItemsArr[vTabelidx] = {...(uItemsArr[vTabelidx]||{}),
			diagnosa_id: uTabelitemObj.diagnosa_id,
			diagnosa_caption: (uTabelitemObj.diagnosa_caption||"").trim(),
			diagnosa_keterangan: (uTabelitemObj.diagnosa_keterangan||"").trim(),
			tindakan: UFunc.nl2br((uTabelitemObj.tindakan||"").trim()),
			keterangan: (uTabelitemObj.keterangan||"").trim(),
			odontogram_arr: uTabelitemObj.odontogram_arr||[],
			qty_terapi: uTabelitemObj.qty_terapi||1,
			diskon_terapi: uTabelitemObj.diskon_terapi||0,
		}
		uItemsArr[vTabelidx].diagnosa_id 		= uTabelitemObj.diagnosa_id || 0;
		uItemsArr[vTabelidx].diagnosa_caption	= (uTabelitemObj.diagnosa_caption||"").trim();
		uItemsArr[vTabelidx].diagnosa_keterangan= (uTabelitemObj.diagnosa_keterangan||"").trim();
		uItemsArr[vTabelidx].tindakan 			= UFunc.nl2br((uTabelitemObj.tindakan||"").trim());
		uItemsArr[vTabelidx].keterangan 		= (uTabelitemObj.keterangan||"").trim();
		//uItemsArr[vTabelidx].odontogram_arr 	= uTabelitemObj.odontogram_arr||[];
		uItemsArr[vTabelidx].qty_terapi 		= uTabelitemObj.qty_terapi||1;
		uItemsArr[vTabelidx].diskon_terapi 		= uTabelitemObj.diskon_terapi||0;
		//--*/
		const vTmpObj 	= {...uItemsArr[_IDXITEM],
			diagnosa_id: uTabelitemObj.diagnosa_id,
			diagnosa_caption: (uTabelitemObj.diagnosa_caption||"").trim(),
			diagnosa_keterangan: (uTabelitemObj.diagnosa_keterangan||"").trim(),
			tindakan: UFunc.nl2br((uTabelitemObj.tindakan||"").trim()),
			keterangan: (uTabelitemObj.keterangan||"").trim(),
			odontogram_arr: uTabelitemObj.odontogram_arr||[],
			qty_terapi: uTabelitemObj.qty_terapi||1,
			diskon_terapi: uTabelitemObj.diskon_terapi||0,
		}
		uItemsArr[_IDXITEM] = vTmpObj;
		setDatamainObj({...uDatamainObj, items_arr: uItemsArr,});
		//---END PROSES_EDIT--/

		setTabelitemObj({});
		setUpdatefield(!uUpdatefield);
		//console.log("(Periksa - hdlKlikTabelsimpan) DONE ");
	}
	const hdlKlikTabeledit = (_IDXITEM) => {
		_IDXITEM = parseInt(_IDXITEM); if(_IDXITEM < 0) return;
		
		if(uISCellphoneview) {
			hdlKlikTabelEditmobile(_IDXITEM);
			return;
		}

		const vTmpObj = {
			tabelidx: _IDXITEM,
			diagnosa_id: uItemsArr[_IDXITEM].diagnosa_id||0, 
			diagnosa_caption: uItemsArr[_IDXITEM].diagnosa_caption||"", 
			diagnosa_keterangan: uItemsArr[_IDXITEM].diagnosa_keterangan||"", 
			tindakan: UFunc.br2nl(uItemsArr[_IDXITEM].tindakan||""), 
			keterangan: uItemsArr[_IDXITEM].keterangan||"", 
			odontogram_arr: uItemsArr[_IDXITEM].odontogram_arr||[], 
			tarif_terapi: uItemsArr[_IDXITEM].tarif_terapi||0, 
			qty_terapi: uItemsArr[_IDXITEM].qty_terapi||1, 
			diskon_terapi: uItemsArr[_IDXITEM].diskon_terapi||0, 
		}
		setTabelitemObj(vTmpObj);
		//setEfekview(!uEfekview);

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout)
			const vElfocus = document.getElementById("inptabelitemdiagnosa"+_IDXITEM);
			vElfocus && vElfocus.focus();
		},350)
	}
	const hdlKlikTabelhapus = async(_IDXITEM) => {
		_IDXITEM = parseInt(_IDXITEM); if(_IDXITEM < 0) return;

		const vFuncnext = () => {
			uItemsArr.splice(_IDXITEM,1);
			uDatamainObj.items_arr = uItemsArr;
			setUpdatefield(!uUpdatefield);
		}

		if(await(Konfirm("Apakah Yakin Akan Dihapus ?"))) vFuncnext()
	}
	const hdlKlikTambahitemmobile = () => {
		setDlgformheader("Assesment, Plan, & Terapi");
		uDlgformdataObj.jenis 		= "FORMTERAPI";
		setDlgformshow(true);
	}
	const hdlKlikTabelEditmobile = (_IDXITEM) => {
		const vArridx = parseInt(_IDXITEM);

		setTabelitemObj({});
		setDlgformdataObj({
			idxtabel: vArridx,
			terapi_sub_id: uItemsArr[vArridx].id_terapi_sub || 0,
			terapi_caption: uItemsArr[vArridx].caption_terapi,
			terapi_tarif: uItemsArr[vArridx].tarif_terapi,
			terapi_main: uItemsArr[vArridx].id_terapi_sub,
			diagnosa_id: uItemsArr[vArridx].diagnosa_id,
			diagnosa_caption: uItemsArr[vArridx].diagnosa_caption,
			diagnosa_keterangan: uItemsArr[vArridx].diagnosa_keterangan,
			tindakan: (uItemsArr[vArridx].tindakan),
			ketgigi: uItemsArr[vArridx].keterangan,
			odontogram_arr: uItemsArr[_IDXITEM].odontogram_arr||[], 
			status_garansi: uItemsArr[vArridx].status_ada_garansi,
			terapi_qty: uItemsArr[vArridx].qty_terapi || 1,
			terapi_diskon: uItemsArr[vArridx].diskon_terapi || 0,
			jenis:  "FORMTERAPI",
		});

		setDlgformheader("EDIT: Assesment, Plan, & Terapi");
		setDlgformshow(true);
	}
	const hdlKDownFormitemcaption = (_EV) => {//--TIDAK_DIPAKAI--/
		uDlgformdataObj.terapi_sub_id 	= 0;
		uDlgformdataObj.terapi_tarif  	= 0;
		uDlgformdataObj.terapi_main		= "";
		uDlgformdataObj.status_garansi 	= 0;
		uDlgformdataObj.terapi_qty 		= 0;
		if(_EV.keyCode !== 13) { setEfekview(!uEfekview); return; }
 		const vTerapicaption	= (uDlgformdataObj.terapi_caption||"").trim();
		if(vTerapicaption === "") { setEfekview(!uEfekview); return; }

		_EV.preventDefault()
		_EV.stopPropagation();

		const vArrCariMaster 	= uDataterapiArr.filter((vItem)=>
			vItem.terapi_caption.toUpperCase().includes((vTerapicaption).toUpperCase()));
		
		if (vArrCariMaster.length === 1) {
			uDlgformdataObj.terapi_sub_id	= (vArrCariMaster[0].id);
			uDlgformdataObj.terapi_caption	= (vArrCariMaster[0].terapi_caption);
			uDlgformdataObj.terapi_tarif	= parseInt(vArrCariMaster[0].terapi_tarif || 0);
			uDlgformdataObj.terapi_main		= (vArrCariMaster[0].terapi_main);
			uDlgformdataObj.status_garansi 	= vArrCariMaster[0].status_garansi;
			uDlgformdataObj.terapi_qty		= 1;

			setEfekview(!uEfekview);
			document.getElementById("inpformitemqty") &&
				document.getElementById("inpformitemqty").focus();
			return;
		}

		hdlKlikFormitemlookup();
	}
	const hdlKlikFormitemlookup = () => {
		//--CEK_IDDOKTER--/
		const vDokteridx = UFunc.getObjectIndeks(uDatadokterArr,uDatamainObj.id_dokter);
		if(vDokteridx < 0) {
			showToast("Nama Dokter Harus Dipilih Terlebih Dahulu !"); return;
		}
		const vArrkompetensiID = uDatadokterArr[vDokteridx].kompetensi_arr || [];
		//--END CEK_IDDOKTER--/

		setInpDlglookup(uDlgformdataObj.terapi_caption||"");
		setDlglookupjenis("FORMTERAPI");


		const vTmpArr	= uDataterapiArr.filter(vItems =>{
			return (parseInt(vItems.id_kompetensi||0) <= 0 ||
				vArrkompetensiID.includes(vItems.id_kompetensi.toString())
			);
		}).map(vItems => {
			return {
				id:vItems.id,
				caption:vItems.terapi_caption,// +" ("+vItems.id_kompetensi+")",
				harga_satuan:vItems.terapi_tarif
			}
		});

		/*const vTmpArr	= uDataterapiArr.map(vItems => {
			return {
				id:vItems.id,
				caption:vItems.terapi_caption,
				harga_satuan:vItems.terapi_tarif
			}
		});//-*/
		setDataDlglookupArr(vTmpArr);
		setDlglookupheader("Pilih: TERAPI");
		setDlglookupshow(true);
	}
	const hdlKlikFormitemdiagnosalookup = () => {
		setInpDlglookup("");
		setDlglookupjenis("DIAGNOSAFORM");

		const vTmpArr	= uDatadiagnosaArr.map(vItems => {
			return {id:vItems.id,caption:vItems.nama_diagnosa}});
		setDataDlglookupArr(vTmpArr);
		setDlglookupheader("Pilih: DIAGNOSA");
		setDlglookupshow(true);
	}
	const hdlKlikDlgperawatsimpan = () => {
		if(uPerawatselectingArr.length <= 0) {
			setDlgperawatshow(false);
			return;
		}

		const vPerawatNOchangeArr = (uDatamainObj.perawat_arr||[]).
			filter(vItems=> {
				const vArridx = UFunc.getObjectIndeks(uPerawatselectingArr,vItems.id_perawat);
				return vArridx < 0 //|| (vArridx >= 0 && (uPerawatselectingArr[vArridx].status_hapus||"TIDAK") !== "YA")
			}); 
		const vPerawatupdateArr	= uPerawatselectingArr.
			filter(vItems=>(parseInt(vItems.id_item)||0) > 0).//-->ID_ITEM = trekammedis_perawat.id
			map(vItems => {
				return {...vItems,
					id_item: undefined,
					id: vItems.id_item,
					id_perawat: vItems.id,
				}
		});
		const vPerawatnewArr	= uPerawatselectingArr.
			filter(vItems=>(parseInt(vItems.id_item)||0) <= 0 && (vItems.status_hapus||"TIDAK")!=="YA").
			map(vItems => {
				return {...vItems,
					id_item: undefined,
					id: vItems.id_item,
					id_perawat: vItems.id,
				}
		});

		const vValuenewArr	= [...vPerawatNOchangeArr,...vPerawatupdateArr,...vPerawatnewArr];
		setDatamainObj({...uDatamainObj,
			perawat_arr: vValuenewArr
		});
		setDlgperawatshow(false);

		//--BEFORE_COMPONENT--/
		return;
		if((uDlgperawatdataObj.perawat_selecting_arr || []).length <= 0) {
			setDlgperawatshow(false);
			return;
		}

		//--CEK_RATE_MIN_3_HARUS_PAKE_NOTE--/
		const vPerawatrate3Arr	= (uDlgperawatdataObj.perawat_selecting_arr || []).
			filter(vItems=>
				parseInt(vItems.rate_bintang||0) > 0 && parseInt(vItems.rate_bintang||0) < 3 && (vItems.catatan||"").trim() === ""
			);

		if(vPerawatrate3Arr.length > 0) {
			showToast("Ada Perawat dengan Rate Kurang dari 3, dan Belum DIBERI CATATAN !");
			return;
		}
		//--END CEK_RATE_MIN_3_HARUS_PAKE_NOTE--/

		//--GET_NEW_ARRPERAWAT--/
		const vPerawatselectnewArr	= (uDlgperawatdataObj.perawat_selecting_arr || []).filter(
			vItems=>{
				const vPerawatidx = UFunc.getObjectIndeks(uPerawatArr,vItems.id);

				return (vPerawatidx < 0 && (parseInt(vItems.rate_bintang)||0) > 0);
			}).map(vItems=>{
				const vArridx 			= UFunc.getObjectIndeks(uDataperawatArr,vItems.id);
				vItems.nama_perawat	= (uDataperawatArr[vArridx]||{}).nama_perawat || "Undf PERAWAT";

				return vItems;
			});
		//--END GET_NEW_ARRPERAWAT--/

		//--EDIT_PERAWAT--/
		const vPerawatselecteditArr	= uPerawatArr.map(vItems=>{
			const vPerawatselectingArr = (uDlgperawatdataObj.perawat_selecting_arr || []).
				filter(vItemselect=>
					parseInt(vItemselect.id)===parseInt(vItems.id) 
				);

			if(vPerawatselectingArr.length > 0) {
				vItems.rate_bintang 	= vPerawatselectingArr[0].rate_bintang || 0;
				vItems.catatan	= vPerawatselectingArr[0].catatan || "";
			}
			return vItems
		}).filter(vItems => (parseInt(vItems.rate_bintang)||0) > 0);
		//--END EDIT_PERAWAT--/

		//--EDIT_PERAWAT_SELECTED--/
		setDatamainObj({...uDatamainObj,
			perawat_arr: [
				...vPerawatselecteditArr,
				...vPerawatselectnewArr,
			]
		});
		//console.log("vPerawatselectnewArr",JSON.stringify(vPerawatselectnewArr));
		//--END EDIT_PERAWAT_SELECTED--/

		setDlgperawatshow(false);
		//--END BEFORE_COMPONENT--/
	}
	const hdlKlikSimpanmain = async() => {
		if(!uIsFormupdate) return;
		if(uTabelitemObj.tabelidx !== undefined) {
			showToast("Kemungkinan Proses <b>Edit Terapi Masih BELUM Disimpan</b>..<br/>Mohon dicek Terlebih Dahulu !");
			return;
		}
		let vElfocus = document.getElementById("inptglperiksa");
		if((uDatamainObj.tgl_periksa||"").trim()==="") {
			vElfocus && vElfocus.focus()
			showToast("Tanggal Antrian Tidak Valid !"); return
		}
		const vTglantriDT = UFunc.toDate(uDatamainObj.tgl_periksa);
		if(UFunc.DateIsBeyond(vTglantriDT)) {
			vElfocus && vElfocus.focus()
			showToast("Tanggal Antrian Melewati Hari Ini !"); return
		}
		vElfocus = document.getElementById("inpdoktercaption");
		if(parseInt(uDatamainObj.id_dokter||0) <= 0) {
			vElfocus && vElfocus.focus()
			showToast("Dokter Harus Dipilih !"); return
		}
		vElfocus = document.getElementById("inpanamnasecaption");
		if((uDatamainObj.anamnase||"").trim()==="") {
			vElfocus && vElfocus.focus()
			showToast("Anamnase Harus Dipilih !"); return
		}
		if((uPerawatArr.length) <= 0) {
			showToast("Belum Ada PERAWAT yang Disertakan !"); return
		}
		if((uItemsArr.length) <= 0) {
			showToast("Belum Ada Item Terapi yang Diinputkan !"); return
		}

		//showToast(JSON.stringify(uDatamainObj)); return;

		if(await(Konfirm(
			//"<b>Simpan Billing PERIKSA</b>.."+
			//"<br/><br/>"+
			//"<div>"+uDatamainObj.dokter_id+"</div>"+
			"<div class='d-flex justify-content-between mx-3'>"+
				"<div>Tgl Periksa</div>"+
				"<b>"+UFunc.TglAngka(uDatamainObj.tgl_periksa)+"</b>"+
			"</div>"+
			"<div class='d-flex justify-content-between mx-3'>"+
				"<div>Dokter</div>"+
				"<b class='text-primary'>"+uDatamainObj.nama_dokter+"</b>"+
			"</div>"+
			"<div class='d-flex justify-content-between mx-3'>"+
				"<div>Perawat</div>"+
				"<div class='ps-2 fst-italic text-end d-block'>"+
				(uPerawatArr.map((vItems)=>{
					return vItems.nama_perawat;
				})).join(" &middot; ")+
				"</div>"+
			"</div>"+

			"<hr class='border-none border-botom' />"+

			"<div class='d-flex justify-content-between mx-3'>"+
				"<div>Jumlah Terapi</div>"+
				"<div><b>"+UFunc.formatAngka(uItemsArr.length)+"</b> Terapi</div>"+
			"</div>"+
			"<div class='d-flex justify-content-between mx-3'>"+
				"<div>Nilai Terapi</div>"+
				"<div class='text-success'>Rp "+UFunc.formatAngka(uDatamainObj.nilai_bruto)+"</div>"+
			"</div>"+
			/*(parseInt(uDatamainObj.nilai_diskon) <=0 ? "" 
				: "<div class='d-flex justify-content-between mx-3 text-danger'>"+
				"<div>Diskon</div>"+
				"<div class=''>Rp "+UFunc.formatAngka(uDatamainObj.nilai_diskon)+"</div>"+
				"</div>"+
				"")+//-*/
			
			"<hr class='border-none border-botom' />"+
			"<div class='d-flex justify-content-between mx-3 fw-bolder'>"+
				"<big>Nilai TOTAL</big>"+
				"<big class='text-success'>Rp "+UFunc.formatAngka(uDatamainObj.nilai_netto)+"</big>"+
			"</div>"+

			"<br/><br/>"+
			"<center>Apakah Yakin Akan Menyimpan ?</center>"+
			""))) apiSimpanmain()
	}
	//---END HANDEL--/

	//---INIT_PROCESS--/
	const initResetmain = () => {
		uDispatch({type: "set", gBillingperiksaObj: undefined});
		setDatamainObj({}); setTambahitemObj({}); setTabelitemObj({});
	}
	const initResettambahform = () => {//-->RESET_SEMUA_KECUALI_CAPTION--/
		setTambahitemObj({terapi_caption: uTambahitemObj.terapi_caption}); return;
		uTambahitemObj.id 				= undefined;
		uTambahitemObj.terapi_tarif 	= undefined;
		uTambahitemObj.status_garansi 	= undefined;
		uTambahitemObj.terapi_main 		= undefined;
		uTambahitemObj.terapi_qty 		= undefined;
		setEfekview(!uEfekview)
	}
	const lookupPilihdokter = (_IDITEM) => {
		_IDITEM = parseInt(_IDITEM)||0; if(_IDITEM <= 0) return;

		const vArridx	= UFunc.getObjectIndeks(uDatadokterArr,_IDITEM);

		uDatamainObj.id_dokter 		= uDatadokterArr[vArridx].id;
		uDatamainObj.nama_dokter 	= uDatadokterArr[vArridx].dokter_caption;
		setUpdatefield(!uUpdatefield)

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout)
			let vElfocus = document.getElementById("btntambahperawat");
			if(!vElfocus)
				vElfocus = document.getElementById("inpanamnasecaption");
			
			vElfocus && vElfocus.focus()
		},350)
	}
	const lookupPilihanamnase = (_IDITEM) => {
		_IDITEM = parseInt(_IDITEM)||0; if(_IDITEM <= 0) return;

		const vArridx	= UFunc.getObjectIndeks(uDataanamnaseArr,_IDITEM);

		uDatamainObj.anamnase_id 	= uDataanamnaseArr[vArridx].id;
		uDatamainObj.anamnase 		= uDataanamnaseArr[vArridx].anamnase_caption;
		setUpdatefield(!uUpdatefield)

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout)
			const vElfocus = document.getElementById("inptambahitemdiagnosa");
			vElfocus && vElfocus.focus()
		},350)
	}
	const lookupPilihcatdokter = (_IDITEM) => {
		_IDITEM = parseInt(_IDITEM)||0; if(_IDITEM <= 0) return;

		const vArridx	= UFunc.getObjectIndeks(uDatacatdokterArr,_IDITEM);

		uDatamainObj.note_dokter 	= uDatacatdokterArr[vArridx].note_caption||"";
		setUpdatefield(!uUpdatefield)

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout)
			const vElfocus = document.getElementById("inpcatatantambahan");
			vElfocus && vElfocus.focus()
		},350)
	}
	const lookupPilihterapi = (_IDITEM) => {//--TIDAK_DIPAKAI--/
		_IDITEM = parseInt(_IDITEM)||0; if(_IDITEM <= 0) return;

		const vArridx	= UFunc.getObjectIndeks(uDataterapiArr,_IDITEM);

		uTambahitemObj.id 				= uDataterapiArr[vArridx].id;
		uTambahitemObj.terapi_caption 	= uDataterapiArr[vArridx].terapi_caption;
		uTambahitemObj.terapi_tarif 	= uDataterapiArr[vArridx].terapi_tarif;
		uTambahitemObj.status_garansi 	= uDataterapiArr[vArridx].status_garansi;
		uTambahitemObj.terapi_main		= (uDataterapiArr[vArridx].terapi_main);
		uTambahitemObj.terapi_qty 		= 1;
		setEfekview(!uEfekview)

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout)
			const vElfocus = document.getElementById("inptambahitemqty");
			vElfocus && vElfocus.focus()
		},350)
	}
	const lookupPilihdiagnosa = (_IDITEM) => {
		_IDITEM = parseInt(_IDITEM)||0; if(_IDITEM <= 0) return;

		const vISTambah	= JSON.stringify(uTabelitemObj||{})==="{}";
		const vArridx	= UFunc.getObjectIndeks(uDatadiagnosaArr,_IDITEM);

		let vElfocus;
		if(vISTambah) {
			vElfocus = document.getElementById("inptambahitemdiagnosaket");
			uTambahitemObj.diagnosa_id		= uDatadiagnosaArr[vArridx].id;
			uTambahitemObj.diagnosa_caption	= uDatadiagnosaArr[vArridx].nama_diagnosa;
		} else {
			uTabelitemObj.diagnosa_id		= uDatadiagnosaArr[vArridx].id;
			uTabelitemObj.diagnosa_caption	= uDatadiagnosaArr[vArridx].nama_diagnosa;
			vElfocus = document.getElementById("inptabelitemdiagnosaket");
		}
		setEfekview(!uEfekview)

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout)
			vElfocus && vElfocus.focus()
		},350)
	}
	const lookupPilihFormdiagnosa = (_IDITEM) => {
		_IDITEM = parseInt(_IDITEM)||0; if(_IDITEM <= 0) return;

		const vArridx	= UFunc.getObjectIndeks(uDatadiagnosaArr,_IDITEM);
		uDlgformdataObj.diagnosa_id		= uDatadiagnosaArr[vArridx].id;
		uDlgformdataObj.diagnosa_caption= uDatadiagnosaArr[vArridx].nama_diagnosa;
		setEfekview(!uEfekview);

		const vElfocus = document.getElementById("inpformitemdiagnosaketerangan");
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout)
			vElfocus && vElfocus.focus()
		},350)
	}
	const lookupFormterapi = (_IDITEM) => {//--TIDAK_DIPAKAI--/
		_IDITEM = parseInt(_IDITEM)||0; if(_IDITEM <= 0) return;

		const vArridx	= UFunc.getObjectIndeks(uDataterapiArr,_IDITEM);

		setDlgformdataObj({...uDlgformdataObj,
			terapi_sub_id: uDataterapiArr[vArridx].id,
			terapi_caption: uDataterapiArr[vArridx].terapi_caption,
			terapi_tarif: uDataterapiArr[vArridx].terapi_tarif,
			status_garansi: uDataterapiArr[vArridx].status_garansi,
			terapi_main: (uDataterapiArr[vArridx].terapi_main),
			terapi_qty: 1,
			terapi_diskon: 0
		});

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			const vElfocus = document.getElementById("inpformitemqty");

			vElfocus && vElfocus.focus()
		},350)
	}
	const initKlikformitem = () => {
		//const vTerapiID = parseInt(uDlgformdataObj.terapi_sub_id)||0; if(vTerapiID <= 0) return;

		const vArridx = uDlgformdataObj.idxtabel===undefined 
			? -1 : parseInt(uDlgformdataObj.idxtabel);

		if(vArridx >= 0) {
			uItemsArr[vArridx] = {...(uItemsArr[vArridx]||{}),
				diagnosa_id: uDlgformdataObj.diagnosa_id,
				diagnosa_caption: (uDlgformdataObj.diagnosa_caption||"").trim(),
				diagnosa_keterangan: (uDlgformdataObj.diagnosa_keterangan||"").trim(),
				tindakan: (uDlgformdataObj.tindakan||"").trim(),
				keterangan: (uDlgformdataObj.ketgigi||"").trim(),
				status_ada_garansi: (uDlgformdataObj.status_garansi||"TIDAK"),
				qty_terapi: uDlgformdataObj.terapi_qty||1,
				diskon_terapi: uDlgformdataObj.terapi_diskon || 0,
			}

			hdlToggleDlgform();
			return;
		}

		const vTerapimain = uDlgformdataObj.terapi_main || "";
		const vArrterapitambah = (uDlgformdataObj.terapi_arr ||[]).map(vItems=>{
			return {
				id_terapi_sub : parseInt(vItems.id)||0,
				caption_terapi : vItems.terapi_caption || "",
				tarif_terapi: parseFloat(vItems.terapi_tarif) || 0,
				qty_terapi: parseInt(uDlgformdataObj.terapi_qty) || 1,
				diskon_terapi: parseFloat(uDlgformdataObj.terapi_diskon) || 0,
				diagnosa_id: uDlgformdataObj.diagnosa_id || 0,
				diagnosa_caption : (uDlgformdataObj.diagnosa_caption||"").trim(),
				diagnosa_keterangan : (uDlgformdataObj.diagnosa_keterangan||"").trim(),
				tindakan : (uDlgformdataObj.tindakan||"").trim(),
				keterangan : (uDlgformdataObj.ketgigi||"").trim(),
				status_ada_garansi : (uDlgformdataObj.status_garansi||"TIDAK"),
				tgl_batas_garansi : "",
			}
		})

		setDatamainObj({...uDatamainObj,
			items_arr: [...vArrterapitambah,...uItemsArr],
		});

		const vTmpresetObj = {
			jenis: uDlgformdataObj.jenis,
			terapi_caption : vTerapimain,
		}
		setDlgformdataObj({...uDlgformdataObj,
			jenis: uDlgformdataObj.jenis,
		});
		showToast(uBahasaObj.pesan_sukses,"SUKSES");
	}
	//---END INIT_PROCESS--/

	//---CONTENT--/
	const contentHeadermain = () => {
		if(uHtml500msg || uHeaderloading) 
			return (<b>{uBahasaObj.caption_billingperiksa||"Billing Periksa"}</b>)//>

		return (
		<>
		<b className="d-none d-lg-inline">{uBahasaObj.caption_billingperiksa||"Billing Periksa"}: </b>
		<span className="text-info fw-bolder d-none d-md-inline">{uDatapasienObj.pasien_caption||"UNDF"}</span>
		<span className="text-info fw-bolder d-md-none">{UFunc.Usercaptionfilter(uDatapasienObj.pasien_caption)}</span>
		<span className="mx-1 d-none d-md-inline">&middot;</span>
		<b className="d-none d-md-inline" style={{color:((uDatapasienObj.sex||"L")==="P"?"pink":"navy")}}>
			[<span>{uDatapasienObj.sex||"L"}</span>]
		</b>

		{(uDatapasienObj.asuransi_caption||"")!=="" && (
			<span className="classfontsmaller d-none d-md-inline">
			<span className="mx-1">&middot;</span>
				<CBadge color="light" className="" style={{color:"purple",border:"1px solid purple"}}>
				<small className="fst-italic" style={{}}>{uDatapasienObj.asuransi_caption}</small>

				{(parseInt(uDatapasienObj.max_terapi)||0) > 0 && (
				<>
				<span className="mx-1">&middot;</span>
				<small className="">(Max: <big>{uDatapasienObj.max_terapi}</big> Terapi)</small>
				</>
				)}
				</CBadge>
			</span>
		)}
		</>
		)//>
	}
	const contentHeadersub = () => {
		if(uHeaderloading) return (<div className="text-primary classblinking ps-3">Loading..</div>)//>
		if(uHtml500msg) return "";

		const vTgllahirDT 	= (uDatapasienObj.tgl_lahir||"")===""?null:UFunc.toDate(uDatapasienObj.tgl_lahir);
		const vTglnowDT		= new Date();
		const vISBirthdaytoday = vTgllahirDT 
			? (vTgllahirDT.getDate() === vTglnowDT.getDate() &&
				vTgllahirDT.getMonth() === vTglnowDT.getMonth()) : false;

		return (
		<small>
		<div>
			{(uDatapasienObj.pekerjaan_caption||"")!=="" && (
			<>
				<b className="text-primary">{uDatapasienObj.pekerjaan_caption}</b>
				<span className="mx-2">&middot;</span>
			</>
			)}

			{(uDatapasienObj.tgl_lahir||"")!=="" && (
			<>
				({uDatapasienObj.umur||"0th"} - {UFunc.TglAngka(uDatapasienObj.tgl_lahir)}
				{vISBirthdaytoday && (
				<>
					<span className="ms-1">&middot;</span>
					<CTooltip className="d-none d-lg-block" content="--Pasien Berulang Tahun Hari Ini--">
					<CImage src={pjson.homepage+"api/images/icon_birthday.png"} className="classblinking" height={30}/>
					</CTooltip>
				</>
				)}
				)
				<span className="mx-2">&middot;</span>
			</>
			)}

			{(uDatapasienObj.kondisi_khusus||"").length >= 3 && (
			<>
			<span className="classblinking text-success">{uDatapasienObj.kondisi_khusus}</span>
			<span className="mx-2">&middot;</span>
			</>
			)}

			{(uDatamainObj.progress_keterangan||"")!=="" && (
			<small className="fst-italic text-danger">
				Ini untuk keterangan
			</small>
			)}
		</div>
		
		{(((uDatapasienObj.pekerjaan_caption||"")!=="" ||
			(uDatapasienObj.tgl_lahir||"")!=="" || 
			(uDatamainObj.progress_keterangan||"")!=="" || 
			(uDatapasienObj.kondisi_khusus||"").length >= 3) && 
			(uDatapasienObj.alergi||"").length >= 3) && (
			<div className="classborderbottom mt-1"/>
		)}

		{(uDatapasienObj.alergi||"").length >= 3 && (
		<>
		<div className="fst-italic text-warning">
			<marquee>&middot;&middot; Alergi: {uDatapasienObj.alergi} &middot;&middot;</marquee>
		</div>
		</>
		)}
		</small>
		)//>
	}
	const contentTanggal = () => {
		if(uHtml500msg) return "";

		return (
		<>
		<CRow className="my-1">
		<CCol xs="3" md="4" className="d-none d-md-block">Tgl Periksa</CCol>
		<CCol className="text-start text-md-end">
		{((uTokenObj.userhak === "FREEROLE" || uTokenObj.userhak === "ADMIN")
			&& (parseInt(uDatamainObj.progress_id)||0) <= 0
		) ? (
			<>
			<CFormInput	size="sm" type="date"
				value={uDatamainObj.tgl_periksa||""}
				onChange={(e)=>setDatamainObj({...uDatamainObj,tgl_periksa:e.target.value})}
				id="inptglperiksa"/>
			<div className="d-none">tgl_periksa= {uDatamainObj.tgl_periksa}</div>
			</>
		) : (
			<div className="mb-1">
			<b className="text-primary">{UFunc.HariAngka(uDatamainObj.tgl_periksa)}</b>
			</div>
		)}
		</CCol>
		</CRow>

		{uTokenObj.userhak !== "DOKTER" && (
		<CRow className="my-1">
		<CCol xs="3" md="4" className="d-none d-md-block">Dokter</CCol>
		<CCol className="text-start text-md-end">
			{(parseInt(uDatamainObj.progress_id)||0) <= 0 ? (
			<CInputGroup size="sm">
			<CFormInput	size="sm" readOnly={true}
				placeholder={"--"+(uBahasaObj.caption_pilihdokter||"Pilih Dokter").toUpperCase()+".."}
				onClick={()=>hdlKlikDokterlookup()}
				value={uDatamainObj.nama_dokter||""}
				onChange={(e)=>setDatamainObj({...uDatamainObj,nama_dokter:e.target.value})}
				id="inpdoktercaption"/>
			<CButton size="sm" color="dark"
				onClick={()=>hdlKlikDokterlookup()}
				id="btndokterlookup">
				<CIcon icon="cilSearch"/>
			</CButton>
			</CInputGroup>
			) : (
			<div className="mb-1">
				<b className="text-primary">{(uDatamainObj.nama_dokter)}</b>
			</div>
			)}
		</CCol>
		</CRow>
		)}
		</>
		)//>
	}
	const contentPerawat = () => {
		if(uHtml500msg) return ""

		return (
		<div className="d-flex justify-content-center align-items-center h-100">
		{uPerawatArr.length <= 0 ? (
		<CButton size="sm" color="dark"
			onClick={()=>hdlKlikPerawat()}
			className="px-3"
			id="btntambahperawat">
			<CIcon icon="cibAddthis" className="me-2"/>
			Pilih Perawat
		</CButton>
		) : (
		<div className="w-100">
		<div className="d-none mb-3">{JSON.stringify(uDataperawatArr)}</div>
		<div className=" text-center">
			<b className="mx-1">&middot;</b>
			{uPerawatArr.map((vItems,vKeys)=>{
				return (
				<span key={vKeys}>
					<span className="text-primary fst-italic">{vItems.nama_perawat||""}</span>
					<b style={{width:24,height:24}}
						className="position-relative ms-1  d-inline-block align-middle">
						<CIcon icon="cilBadge" className="position-absolute text-warning" 
							style={{
								top:"50%",left:"50%",
								transform: "translate(-50%, -50%)",
							}} 
							height={24}/>
						<small style={{
								top: "35%",
								left: "50%",
								transform: "translate(-50%, -50%)",
								fontSize:10,
							}}
							className="position-absolute text-danger">{vItems.rate_bintang}</small>
					</b>
					{(vItems.catatan||"").trim() !== "" && (
						<CIcon icon="cilNotes" className="text-success align-middle" height={24}/>
					)}

					<b className="mx-1">&middot;</b>
				</span>
				)
			})}
		</div>

		<div className="my-1 classborderbottom"/>

		<div className="text-center">
			<CTooltip className="d-none d-lg-block" content="--Edit Perawat">
			<CLink className="classcursorpointer classikontabel classikonedit"
				onClick={()=>hdlKlikPerawat()}/>
			</CTooltip>

			<CTooltip className="d-none d-lg-block" content="--Bersihkan Semua">
			<CLink className="classcursorpointer classikontabel classikonhapus"
				onClick={()=>hdlKlikPerawatclear()}/>
			</CTooltip>
		</div>
		</div>
		)}
		</div>
		)//>
	}
	const contentSubjective = () => {
		if(uHtml500msg) return "";

		return (
		<>
		<CRow className="my-1">
		<CCol xs="3" md="4" className="d-none d-md-block">Anamnesa</CCol>
		<CCol className="text-start text-md-end">
			<CInputGroup size="sm">
			<CFormInput	size="sm" readOnly={true}
				placeholder={"--"+(uBahasaObj.caption_pilihanamnase||"Pilih Anamnase").toUpperCase()+".."}
				onClick={()=>hdlKlikAnamnaselookup()}
				value={uDatamainObj.anamnase||""}
				onChange={(e)=>setDatamainObj({...uDatamainObj,anamnase:e.target.value})}
				id="inpanamnasecaption"/>
			<CButton size="sm" color="dark"
				onClick={()=>hdlKlikAnamnaselookup()}
				id="btnanamnaselookup">
				<CIcon icon="cilSearch"/>
			</CButton>
			</CInputGroup>
		</CCol>
		</CRow>

		<CRow className="my-1">
		<CCol xs="3" md="4" className="d-none d-md-block">Keterangan</CCol>
		<CCol className="text-start text-md-end">
		<CFormTextarea size="sm"
			rows={3}
			value={UFunc.br2nl(uDatamainObj.anamnase_teks||"")}
			onChange={(e)=>setDatamainObj({...uDatamainObj,anamnase_teks:UFunc.br2nl(e.target.value)})}
			placeholder="--Keterangan Subjective"
			className="classfontsmaller py-1"
			id="inpsubjectiveket"/>
		{!isMobile && (
		<div className="classfontsmaller fst-italic text-warning text-start px-2"><small>*) {uBahasaObj.petunjuk_textarea}</small></div>
		)}
		</CCol>
		</CRow>
		</>
		)//>
	}
	const contentObjective = () => {
		if(uHtml500msg) return "";

		return (
		<>
		<div style={{height:"80%"}}>
		<CFormTextarea size="sm"
			rows={3}
			value={UFunc.br2nl(uDatamainObj.objective_teks||"")}
			onChange={(e)=>setDatamainObj({...uDatamainObj,objective_teks:UFunc.br2nl(e.target.value)})}
			placeholder="--Keterangan Objective"
			className="classfontsmaller py-1 h-100"
			id="inpsubjectiveket"/>
		</div>
		{!isMobile && (
		<div className="classfontsmaller fst-italic text-warning px-2"><small>*) {uBahasaObj.petunjuk_textarea}</small></div>
		)}
		</>
		)//>
	}
	const contentTabelform = () => {
		if(uHtml500msg) return ""

		if(isMobile || uISTabletview || uISCellphoneview) return (
			<CButton size="sm" color="secondary"
				className="text-white mx-2"
				onClick={()=>hdlKlikTambahitemmobile()}
				id="btnFormitem">
				<CIcon icon="cibAddthis" className="me-1 align-middle"/>
				Tambah Terapi
			</CButton>
		)//>

		return (
		<table className="table table-borderless" className="text-light" id="idtabelformdesktop">
			<thead>
			<tr>
				<th width="3%" style={{minWidth:45}} className="p-0"/>
				<th className="p-0"/>
				<th width="15%" style={{minWidth:175}} className="p-0"/>
			</tr>
			</thead>

			<tbody>
			<tr className="align-top">
				<td className="px-1 text-center">
				<CImage src={pjson.homepage+"api/images/icon_new.png"} height={30}/>
				</td>

				<td className="px-1 text-start">
				<CRow>
				<CCol md="6" className="">
					{(uTambahitemObj.ketgigi||"").trim()==="" ? (
					<div className="">
					<CButton size="sm" color="secondary"
						className="text-start text-white px-2 px-lg-4 text-uppercase"
						onClick={()=>hdlKlikKetgigi()}
						id="btntambahitemketgigi">
						<CIcon icon="cibAddthis" className="me-2 align-middle" height={20}/>
						Pilih Nomor Gigi
					</CButton>
					</div>
					) : (
					<>
						<span className="me-1">Nomor Gigi:</span>
						<b>{uTambahitemObj.ketgigi||""}</b>
					</>
					)}
				</CCol>

				{(uTambahitemObj.ketgigi||"").trim()!=="" && (
				<CCol className="">
					<CLink onClick={async()=>{
							if(await Konfirm("<b>Reset Nomor Gigi</b>.."+
								"<p>Apakah Anda Yakin ?</p>")) { 
								setTambahitemObj({...uTambahitemObj,ketgigi:"",odontogram_arr:[]}) 
							} }} 
							className="classcursorpointer">
						<CIcon icon="cilReload" className="classikonbox mx-0 bg-secondary text-black border-secondary" height={16}/>
					</CLink>

					<CLink className="classcursorpointer" onClick={()=>hdlKlikKetgigi()}>
						<CIcon icon="cilPencil" className="classikonbox bg-secondary text-black border-secondary" height={23}/>
					</CLink>
				</CCol>
				)}
				</CRow>

				<div className="classborderbottom my-3"/>

				<CRow className="my-">
				<CCol md="6">
					<CInputGroup size="sm">
					<CFormInput size="sm" maxLength={255}
						readOnly={true}
						value={uTambahitemObj.diagnosa_caption||""}
						placeholder={"--"+(uBahasaObj.word_diagnosa||"Diagnosa")+".."}
						onClick={()=>hdlKlikDiagnosalookup()}
						style={{backgroundColor:"#DBDBDB"}}
						id="inptambahitemdiagnosa"/>
					<CButton size="sm" color="secondary"
						onClick={()=>hdlKlikDiagnosalookup()}
						id="btntambahitemdiagnosalookup">
						<CIcon icon="cilSearch"/>
					</CButton>
					</CInputGroup>

					<CFormInput size="sm" maxLength={100}
						className="mt-2"
						value={uTambahitemObj.diagnosa_keterangan||""}
						onChange={(e)=>setTambahitemObj({...uTambahitemObj,diagnosa_keterangan:e.target.value})}
						placeholder="--Keterangan Diagnosa.."
						id="inptambahitemdiagnosaket"/>
					<div className="classfontsmaller text-warning">
						<small><b>ASSESSMENT</b></small>
					</div>
				</CCol>

				<CCol>
					<CInputGroup className="" size="sm">
					<CFormTextarea size="sm" rows={3}
						className="classfontsmaller py-1"
						placeholder="--PLAN Perawatan Pasien.."
						value={UFunc.br2nl(uTambahitemObj.tindakan||"")}
						onChange={(e)=>setTambahitemObj({...uTambahitemObj,tindakan:UFunc.nl2br(e.target.value)})}
						id="inptambahitemtindakan"/>
					</CInputGroup>
					{!isMobile && (
					<div className="classfontsmaller text-warning">
						<small><b>PLAN</b> &middot; {uBahasaObj.petunjuk_textarea}</small>
					</div>
					)}
				</CCol>
				</CRow>

				<div className="classborderbottom my-3 mb-2"/>
				</td>

				<td className="px-1 text-end">&nbsp;</td>
			</tr>

			<tr className="align-top">
				<td className="px-1 text-center">&nbsp;</td>
				<td className="px-1 text-start">

				<CRow className="my-">
				<CCol md="6">
					<CInputGroup size="sm">
					<CFormInput size="sm"
						readOnly={true}
						placeholder={"--PILIH LOOKUP TERAPI.."}
						value={uTambahitemObj.terapi_caption||""}
						onClick={()=>hdlKlikTerapilookup()}
						style={{backgroundColor:"#DBDBDB"}}
						id="inptambahitemcaption"/>
					<CButton size="sm" color="secondary" 
						onClick={()=>hdlKlikTerapilookup()}
						id="btntambahitemlookup">
						<CIcon icon="cilSearch"/>
					</CButton>
					</CInputGroup>
					<div className="classfontsmaller text-warning"><small>Terapi</small></div>
				</CCol>

				<CCol md="3" lg="2" className="">
					<CInputGroup size="sm">
					<CFormInput size="sm" maxLength={3}
						type="number"
						className="text-end"
						value={uTambahitemObj.terapi_qty||0}
						onChange={(e)=>setTambahitemObj({...uTambahitemObj,terapi_qty:e.target.value})}
						onFocus={(e)=>e.target.select()}
						id="inptambahitemqty"/>
					<CInputGroupText className="fw-bolder"><small>UNT</small></CInputGroupText>
					</CInputGroup>
				</CCol>

				<CCol className="text-success fw-bolder text-start">
					({(uTambahitemObj.terapi_arr||[]).length} Terapi)
				</CCol>
				</CRow>
				</td>
				
				<td className="px-2 text-end">
				<CButton size="sm" color="secondary"
					className="px-2 px-lg-4 text-white fw-bolder"
					style={{
						backgroundImage: "linear-gradient(to bottom, gray, silver)",
					}}
					onClick={()=>hdlKlikTambahitem()}
					id="btntambahitemadd">
					<CIcon icon="cibAddthis" className="me-1 align-middle"/>TAMBAH
				</CButton>
				</td>
			</tr>
			</tbody>
		</table>
		);//>

		/*//--TIDAK_DIPAKAI--/
		return (
		<CRow className="text-light">
		<CCol md="10" className="d-flex">
		<div style={{width:"3%",minWidth:50}} className="text-start px-1">
			<CImage src={pjson.homepage+"api/images/icon_new.png"} height={30}/>
		</div>

		<div style={{width:"97%"}} className="px-1">
			<div className="d-flex align-items-start">
				<div style={{minWidth:350}} className="w-50">
				<CInputGroup size="sm">
				<CFormInput size="sm" maxLength={255}
					readOnly={true}
					value={uTambahitemObj.diagnosa_caption||""}
					placeholder={"--"+(uBahasaObj.word_diagnosa||"Diagnosa")+".."}
					onClick={()=>hdlKlikDiagnosalookup()}
					id="inptambahitemdiagnosa"/>
				<CButton size="sm" color="secondary"
					onClick={()=>hdlKlikDiagnosalookup()}
					id="btntambahitemdiagnosalookup">
					<CIcon icon="cilSearch"/>
				</CButton>
				</CInputGroup>

				<CFormInput size="sm" maxLength={100}
					className="mt-2"
					value={uTambahitemObj.diagnosa_keterangan||""}
					onChange={(e)=>setTambahitemObj({...uTambahitemObj,diagnosa_keterangan:e.target.value})}
					placeholder="--Keterangan Diagnosa.."
					id="inptambahitemdiagnosaket"/>
				</div>

				<span className="mx-1">&middot;</span>

				<div className="w-50">
				<CInputGroup className="" size="sm">
				<CFormTextarea size="sm" rows={3}
					className="classfontsmaller py-1"
					placeholder={"--"+(uBahasaObj.word_tindakan||"Tindakan")+".."}
					value={UFunc.br2nl(uTambahitemObj.tindakan||"")}
					onChange={(e)=>setTambahitemObj({...uTambahitemObj,tindakan:UFunc.nl2br(e.target.value)})}
					id="inptambahitemtindakan"/>
				</CInputGroup>
				{!isMobile && (
				<div className="classpetunjuk text-warning"><small>*) {uBahasaObj.petunjuk_textarea}</small></div>
				)}
				</div>

				<div className="d-md-none" style={{minWidth:100}}/>
			</div>

			<div className="classborderbottom my-2"/>

			<div className="d-flex align-items-start">
				<div style={{minWidth:350,width:"50%"}}>
				<CInputGroup size="sm">
				<CFormInput size="sm"
					placeholder={"--"+(uBahasaObj.caption_keywordterapi||"Masukkan Keyword Terapi").toUpperCase()+".."}
					value={uTambahitemObj.terapi_caption||""}
					onChange={(e)=>setTambahitemObj({...uTambahitemObj,terapi_caption:e.target.value})}
					onKeyDown={(e)=>hdlKDownTerapicaption(e)}
					id="inptambahitemcaption"/>
				<CButton size="sm" color="secondary"
					onClick={()=>hdlKlikTerapilookup()}
					id="btntambahitemlookup">
					<CIcon icon="cilMagnifyingGlass"/>
				</CButton>
				</CInputGroup>
				<div className="classpetunjuk text-warning"><small>Terapi</small></div>
				</div>

				<div className="mx-2" style={{minWidth:70,width:"10%"}}>
				<CInputGroup size="sm">
				<CFormInput size="sm" maxLength={3}
					type="number"
					className="text-end"
					value={uTambahitemObj.terapi_qty||0}
					onChange={(e)=>setTambahitemObj({...uTambahitemObj,terapi_qty:e.target.value})}
					onFocus={(e)=>e.target.select()}
					id="inptambahitemqty"/>
				</CInputGroup>
				<div className="classpetunjuk text-warning"><small>UNT</small></div>
				</div>

				<CInputGroup style={{minWidth:100,width:"30%"}} size="sm">
				<CFormInput size="sm" maxLength={255}
					placeholder={"--"+(uBahasaObj.caption_ketgigi||"Ket.Gigi")+".."}
					value={uTambahitemObj.ketgigi||""}
					onKeyDown={(e)=>UFunc.hdlKeyDownInput(e,"btntambahitemadd")}
					onChange={(e)=>setTambahitemObj({...uTambahitemObj,ketgigi:e.target.value})}
					id="inptambahitemketgigi"/>
				<CButton size="sm" color="secondary"
					onClick={()=>hdlKlikketgigiview()}
					id="btntambahitemketgigi">
					<CIcon icon="cilMagnifyingGlass"/>
				</CButton>
				</CInputGroup>

				<div className="d-md-none" style={{minWidth:100}}/>
			</div>
		</div>
		</CCol>

		<CCol md="2" className="text-end">
			<div className="text-success fw-bolder pb-3">Rp{UFunc.formatAngka(uTambahitemObj.terapi_tarif)}</div>
			<CButton size="sm" color="secondary"
				className="px-2 px-lg-4 fw-bolder text-white"
				onClick={()=>hdlKlikTambahitem()}
				id="btntambahitemadd">
				<CIcon icon="cibAddthis"/>{" "}Tambah
			</CButton>
		</CCol>
		</CRow>
		)//>
		//--END TIDAK_DIPAKAI--*/
	}
	const contentTabelitem = () => {
		if(uHtml500msg) return "";

		if(uISCellphoneview) return (<>{contentTabelitemmobile()}</>);//>

		return (
		<table className="table table-borderless" id="idtabelitemdesktop">
		<thead>
		<tr>
			<th width="3%" style={{minWidth:45}} className="p-0"/>
			<th className="p-0"/>
			<th width="15%" style={{minWidth:120}} className="p-0"/>
		</tr>
		</thead>

		<tbody>
		{uItemsArr.map((vItems,vKeys)=>{
			const {
				id_terapi_sub,caption_terapi,tarif_terapi,qty_terapi,diskon_terapi,
				diagnosa_caption,diagnosa_id,diagnosa_keterangan,tindakan,keterangan,
				status_ada_garansi,tgl_batas_garansi
			} = vItems;

			const vIdxedit 		= uTabelitemObj.tabelidx===undefined
				? -1 : parseInt(uTabelitemObj.tabelidx);

			return (
			<>
			<tr className={"align-top "+(vKeys%2===0?"bg-light":"bg-white")} key={vKeys}>
				<td className="px-1 text-end">{(vKeys+1)}.</td>
				<td className="px-1 text-start">
					<CRow>
					{(vIdxedit!==vKeys) ? (
					<CCol md="6">
						{(keterangan||"").trim()==="" ? (
							<span className="classpetunjuk px-0">
							<small>&middot; NOMOR GIGI EMPTY &middot;</small>
							</span>
						) : (
							<small>
							<span className="me-1">Nomor Gigi:</span>
							<b className="text-uppercase">{keterangan}</b>
							</small>
						)}
					</CCol>
					): (
					<>
					<CCol md="6">
						{(uTabelitemObj.keterangan||"").trim()==="" ? (
							<CButton size="sm" color="dark"
								className="text-start text-white px-2 px-lg-4 text-uppercase"
								onClick={()=>hdlKlikKetgigi(vKeys)}
								id="btntambahitemketgigi">
								<CIcon icon="cibAddthis" className="me-2 align-middle" height={20}/>
								Pilih Nomor Gigi
							</CButton>
						) : (
							<small>
							<span className="me-1">Nomor Gigi:</span>
							<b className="text-uppercase">{uTabelitemObj.keterangan}</b>
							</small>
						)}
					</CCol>

					<CCol>
						{(uTabelitemObj.keterangan||"").trim()!=="" && (
						<>
						<CLink onClick={async()=>{
							if(await Konfirm("<b>Reset Nomor Gigi</b>.."+
								"<p>Apakah Anda Yakin ?</p>")) { 
								setTabelitemObj({...uTabelitemObj,keterangan:"",odontogram_arr:[]}) 
							} }} 
							className="classcursorpointer">
						<CIcon icon="cilReload" className="classikonbox mx-0 bg-dark border-dark text-white" height={16}/>
						</CLink>

						<CLink onClick={()=>hdlKlikKetgigi(vKeys)} 
							className="classcursorpointer">
						<CIcon icon="cilPencil" className="classikonbox bg-dark border-dark text-white" height={23}/>
						</CLink>
						</>
						)}
					</CCol>
					</>
					)}
					</CRow>

					<div className="my-2 classborderbottom"/>

					<CRow>
					{(vIdxedit!==vKeys) ? (
					<>
					<CCol md="6">
						{((diagnosa_caption||"").trim()==="" && (diagnosa_keterangan||"").trim()==="") ? (
						<span className="classpetunjuk px-0">
							<small>&middot; {uBahasaObj.word_diagnosa||"Diagnosa"}: EMPTY &middot;</small>
						</span>
						) : (
						<>
							<div className="text-capitalize fw-bolder text-primary">{diagnosa_caption}</div>

							{(diagnosa_keterangan||"")!=="" && (
							<div className="text-capitalize classfontsmaller fst-italic" style={{color:"gray"}}>
							<small>{diagnosa_keterangan}</small>
							</div>
							)}
						</>
						)}
					</CCol>

					<CCol>
						{(tindakan||"").trim()==="" ? (
						<div className="classpetunjuk px-0">
							<small>&middot; {uBahasaObj.word_tindakan||"Tindakan"} EMPTY &middot;</small>
						</div>
						) : (
						<span className="text-capitalize" style={{color:"maroon"}}>
							<small>{UFunc.renderHTML(tindakan)}</small>
						</span>
						)}
					</CCol>
					</>
					) : (
					<>
					<CCol md="6" className="my-1">
						<CInputGroup size="sm">
						<CFormInput size="sm" maxLength={255} readOnly={true}
							placeholder={"--"+(uBahasaObj.word_diagnosa||"Diagnosa")+".."}
							value={uTabelitemObj.diagnosa_caption||""}
							onChange={(e)=>setTabelitemObj({...uTabelitemObj,diagnosa_caption:e.target.value})}
							onClick={()=>hdlKlikDiagnosalookup(vKeys)}
							id={"inptabelitemdiagnosa"}/>
						<CButton size="sm" color="dark"
							onClick={()=>hdlKlikDiagnosalookup(vKeys)}
							id={"btntabelitemdiagnosalookup"}>
						<CIcon icon="cilSearch"/>
						</CButton>
						</CInputGroup>

						<CFormInput size="sm" maxLength={100}
							className="mt-2"
							value={uTabelitemObj.diagnosa_keterangan||""}
							onChange={(e)=>setTabelitemObj({...uTabelitemObj,diagnosa_keterangan:e.target.value})}
							placeholder="--Keterangan Diagnosa.."
							id="inptabelitemdiagnosaket"/>
					</CCol>

					<CCol className="my-1">
						<CFormTextarea size="sm" rows={3}
							className="classfontsmaller py-1"
							value={UFunc.br2nl(uTabelitemObj.tindakan||"")}
							onChange={(e)=>setTabelitemObj({...uTabelitemObj,tindakan:UFunc.nl2br(e.target.value)})}
							placeholder={"--PLAN Perawatan Pasien.."}
							id={"inptabelitemtindakan"}/>
					</CCol>
					</>
					)}
					</CRow>

					<div className="my-2 mb-0 classborderbottom"/>
				</td>

				<td className="px-2 text-end">
					{(vIdxedit !== vKeys) ? (
					<>
						<CTooltip className="d-none d-lg-block" content={"--EDIT Item No-"+(vKeys+1)}>
						<CLink className="classcursorpointer classikontabel classikonedit"
							onClick={()=>hdlKlikTabeledit(vKeys)}/>
						</CTooltip>
						<span className="mx-1 d-none d-lg-inline">&middot;</span>
						<CTooltip className="d-none d-lg-block" content={"--HAPUS Item No-"+(vKeys+1)}>
						<CLink className="classcursorpointer classikontabel classikonhapus"
							onClick={()=>hdlKlikTabelhapus(vKeys)}/>
						</CTooltip>
					</>
					) : (<>&nbsp;</>)}
				</td>
			</tr>

			<tr className={"align-top "+(vKeys%2===0?"bg-light":"bg-white")}>
				<td className="px-1">&nbsp;</td>
				<td className="px-1 text-start">
					<CRow className="">
					{(vIdxedit!==vKeys) ? (
					<>
					<CCol md="8" className="">
						<small>{caption_terapi||"UNDF"}</small>
					</CCol>

					<CCol className="text-end">
						<small>
							<b className="text-primary">{qty_terapi||1}</b>unt
							<span className="mx-1">x</span>
							(
							<b className="text-primary">{UFunc.formatAngka(tarif_terapi)}</b>
							{(parseFloat(diskon_terapi)||0) > 0 && (
							<>
								<span className="mx-1">-</span>
								<b className="text-danger">{UFunc.formatAngka(diskon_terapi)}</b>
							</>
							)}
							)
						</small>
					</CCol>
					</>
					) : (
					<>
					<CCol lg="7" className="mb-2 mb-lg-0">
						<small>{caption_terapi||"UNDF"}</small>
					</CCol>
					
					<CCol lg="5" className="d-flex justify-content-lg-end align-items-start">
						<CInputGroup 
							style={{minWidth:90,width:"20%"}}
							size="sm">
							<CFormInput size="sm" type="number"
								className="text-end"
								value={uTabelitemObj.qty_terapi||1}
								onChange={(e)=>setTabelitemObj({...uTabelitemObj,qty_terapi:e.target.value})}
								onFocus={(e)=>e.target.select()}
								id="inptabelitemqty"/>
							<CInputGroupText className="px-1 fw-bolder"><small>UNT</small></CInputGroupText>
						</CInputGroup>

						<span className="mx-2">x</span>

						(<b className="text-primary">{UFunc.formatAngka(tarif_terapi)}</b>

						<span className="mx-1">-</span>
						
						<div className="me-1" style={{minWidth:120,width:"25%"}}>
							<NumberFormat 
								value={uTabelitemObj.diskon_terapi||"0"}
								displayType={'text'} 
								thousandSeparator={"."} 
								decimalSeparator={","}
								allowNegative={false}
								onValueChange={(values) => uTabelitemObj.diskon_terapi=values.value}
								renderText={values => (
									<CFormInput 
										value={values}
										size="sm"
										className="text-end text-danger"
										onChange={(e)=>setTabelitemObj({...uTabelitemObj,diskon_terapi:e.target.value})}
										onFocus={(e)=>e.target.select()}
									id="inptabelitemdiskon"/>
								)} 
							prefix=""/>
							<div className="classpetunjuk px-0"><small>Diskon (Max:{parseInt(uSystemsettingObj.persen_diskonmax)||100}%)</small></div>
						</div>
						)
					</CCol>
					</>
					)}
					</CRow>
				</td>

				<td className="px-2 text-end text-success">
					{(vIdxedit!==vKeys) ? (
					<>
					{UFunc.formatAngka(parseInt(qty_terapi) * (
						(parseFloat(tarif_terapi)||0) - (parseFloat(diskon_terapi)||0)
					))}
					</>
					) : (
						<CButton size="sm" color="dark"
							className="fw-bold text-white px-2 px-lg-3 text-uppercase fw-bold"
							style={{
								backgroundImage: "linear-gradient(to bottom, #212631, #6b7785)",
							}}
							onClick={()=>hdlKlikTabelsimpan(vKeys)}
							id={"btnTabelsimpan"+vKeys}>
							<CIcon icon="cilCheckAlt" className="me-1 align-middle" height={20}/> Simpan
						</CButton>
					)}
				</td>
			</tr>
			</>
			);//>

			/*//--TIDAK_DIPAKAI--/
			return (
			<>
			<tr className={"align-top "+(vKeys%2===0?"bg-light":"bg-white")} key={vKeys}>
				<td className="px-1 text-end" rowSpan={2}>{(vKeys+1)}.</td>
				<td className="px-1 text-start">
					<div className="d-none d-md-flex align-items-start">
					{(vIdxedit!==vKeys) ? (
					<>
						<div style={{width:"50%"}}>
						{(diagnosa_caption||"").trim()==="" ? (
						<small className="classpetunjuk px-0">{uBahasaObj.word_diagnosa||"Diagnosa"}: {"<EMPTY>"}</small>
						) : (
							<div className="text-capitalize fw-bolder">{diagnosa_caption}</div>
						)}

						{(diagnosa_keterangan||"")!=="" && (
						<div className="text-capitalize classfontsmaller fst-italic" style={{color:"gray"}}>
						<small>{diagnosa_keterangan}</small>
						</div>
						)}
						</div>

						<div className="text-center mx-2">&middot;</div>

						<div>
						{(tindakan||"").trim()==="" ? (
							<small className="classpetunjuk px-0">{uBahasaObj.word_tindakan||"Tindakan"}: {"<EMPTY>"}</small>
						) : (
						<span className="text-capitalize classfontsmaller" style={{color:"maroon"}}>
						<small>{UFunc.renderHTML(tindakan)}</small>
						</span>
						)}
						</div>
					</>
					) : (
					<>
					<div style={{width:"50%"}}>
						<CInputGroup size="sm">
						<CFormInput size="sm" maxLength={255} readOnly={true}
							placeholder={"--"+(uBahasaObj.word_diagnosa||"Diagnosa")+".."}
							value={uTabelitemObj.diagnosa_caption||""}
							onChange={(e)=>setTabelitemObj({...uTabelitemObj,diagnosa_caption:e.target.value})}
							onClick={()=>hdlKlikDiagnosalookup(vKeys)}
							id={"inptabelitemdiagnosa"}/>
						<CButton size="sm" color="dark"
							onClick={()=>hdlKlikDiagnosalookup(vKeys)}
							id={"btntabelitemdiagnosalookup"}>
						<CIcon icon="cilSearch"/>
						</CButton>
						</CInputGroup>

						<CFormInput size="sm" maxLength={100}
							className="mt-2"
							value={uTabelitemObj.diagnosa_keterangan||""}
							onChange={(e)=>setTabelitemObj({...uTabelitemObj,diagnosa_keterangan:e.target.value})}
							placeholder="--Keterangan Diagnosa.."
							id="inptabelitemdiagnosaket"/>
						</div>

						<div className="text-center mx-1">&middot;</div>

						<div style={{width:"50%"}} className="">
						<CFormTextarea size="sm" rows={3}
							className="classfontsmaller py-1"
							value={UFunc.br2nl(uTabelitemObj.tindakan||"")}
							onChange={(e)=>setTabelitemObj({...uTabelitemObj,tindakan:UFunc.nl2br(e.target.value)})}
							placeholder={"--"+(uBahasaObj.word_tindakan||"Tindakan")+".."}
							id={"inptabelitemtindakan"}/>
					</div>
					</>
					)}
					</div>
				</td>

				<td className="px-3 text-end">
					{(vIdxedit !== vKeys) ? (
					<>
						<CTooltip className="d-none d-lg-block" content={"--EDIT Item Terapi No-"+(vKeys+1)}>
						<CLink className="classcursorpointer classikontabel classikonedit"
							onClick={()=>hdlKlikTabeledit(vKeys)}/>
						</CTooltip>
						<span className="mx-1">&middot;</span>
						<CTooltip className="d-none d-lg-block" content={"--HAPUS Item Terapi No-"+(vKeys+1)}>
						<CLink className="classcursorpointer classikontabel classikonhapus"
							onClick={()=>hdlKlikTabelhapus(vKeys)}/>
						</CTooltip>
					</>
					) : (
						<CButton size="sm" color="dark"
							className="fw-bold text-white"
							onClick={()=>hdlKlikTabelsimpan(vKeys)}
							id={"btnTabelsimpan"+vKeys}>
							<CIcon icon="cilCheckAlt"/> Simpan
						</CButton>
					)}
				</td>
			</tr>
			
			<tr className={"align-top "+(vKeys%2===0?"bg-light":"bg-white")}>
				<td className="px-1 text-start">
					{(vIdxedit!==vKeys) ? (
					<>
						<small className="d-flex justify-content-between align-items-start">
							<div>{caption_terapi||"UNDF"}</div>

							<div>
							<b className="text-primary">{qty_terapi||1}</b>unt
							<span className="mx-1">x</span>
							(
							<b className="text-primary">{UFunc.formatAngka(tarif_terapi)}</b>
							{(parseFloat(diskon_terapi)||0) > 0 && (
							<>
								<span className="mx-1">-</span>
								<b className="text-danger">{UFunc.formatAngka(diskon_terapi)}</b>
							</>
							)}
							)
							</div>
						</small>

						<div>
						{(keterangan||"").trim()==="" ? (
							<span className="classpetunjuk px-0">
							<small>{uBahasaObj.caption_ketgigi||"Ket.Gigi"}: {"<EMPTY>"}</small>
							</span>
						) : (
							<span className="text-capitalize classfontsmaller">
							<small>{uBahasaObj.caption_ketgigi||"Ket.Gigi"}: <b>{keterangan}</b></small>
							</span>
						)}
						</div>
					</>
					) : (
					<div className="d-flex align-items-start">
						<div>
							<small>{caption_terapi||"UNDF"}</small>
						</div>

						<div className="text-center px-2">:</div>

						<small className="w-50" className="d-flex align-items-start">
							<CInputGroup 
								style={{minWidth:90,width:"15%"}}
								size="sm">
							<CFormInput size="sm" type="number"
								className="text-end"
								value={uTabelitemObj.qty_terapi||1}
								onChange={(e)=>setTabelitemObj({...uTabelitemObj,qty_terapi:e.target.value})}
								onFocus={(e)=>e.target.select()}
								id="inptabelitemqty"/>
							<CInputGroupText className="px-1">UNT</CInputGroupText>
							</CInputGroup>

							<span className="mx-2">x</span>

							(<b className="text-primary">{UFunc.formatAngka(tarif_terapi)}</b>

							<span className="mx-1">-</span>
							<div className="me-1" style={{minWidth:100,width:"20%"}}>
							<NumberFormat 
								value={uTabelitemObj.diskon_terapi||"0"}
								displayType={'text'} 
								thousandSeparator={"."} 
								decimalSeparator={","}
								onValueChange={(values) => uTabelitemObj.diskon_terapi=values.value}
								renderText={values => (
									<CFormInput 
										value={values}
										size="sm"
										className="text-end text-danger"
										onChange={(e)=>setTabelitemObj({...uTabelitemObj,diskon_terapi:e.target.value})}
										onFocus={(e)=>e.target.select()}
									id="inptabelitemdiskon"/>
								)} 
							prefix=""/>
							<div className="classpetunjuk">Diskon (Max:{parseInt(uSystemsettingObj.persen_diskonmax)||100}%)</div>
							</div>
							)
							<span className="mx-2">&middot;</span>

							<CInputGroup 
								style={{minWidth:200,width:"40%"}}
								size="sm">
							<CFormInput size="sm" maxLength={255}
								placeholder={"--"+(uBahasaObj.caption_ketgigi||"Ket.Gigi")+".."}
								value={uTabelitemObj.keterangan||""}
								onKeyDown={(e)=>UFunc.hdlKeyDownInput(e,"btnTabelsimpan"+vKeys)}
								onChange={(e)=>setTabelitemObj({...uTabelitemObj,keterangan:e.target.value})}
								id={"inptabelketgigi"}/>
							<CButton size="sm" color="dark"
								onClick={()=>hdlKlikketgigiview(vKeys)}
								id={"btntabelitemketgigi"+vKeys}>
								<CIcon icon="cilMagnifyingGlass"/>
							</CButton>
							</CInputGroup>
						</small>
					</div>
					)}
				</td>

				<td className="px-2 text-end text-success">
					{(vIdxedit!==vKeys) && (
					<>
					{UFunc.formatAngka(parseInt(qty_terapi) * (
						(parseFloat(tarif_terapi)||0) - (parseFloat(diskon_terapi)||0)
					))}
					</>
					)}
				</td>
			</tr>
			</>
			)//>
			//--END TIDAK_DIPAKAI--*/
		})}
		</tbody>

		<tfoot>
		<tr className="bg-primary text-white fw-bolder">
			<td colSpan={2} className="text-end px-2">JUMLAH (Rp)</td>
			<td className="text-end px-2">{UFunc.formatAngka(uDatamainObj.nilai_bruto)}</td>
		</tr>
		</tfoot>
		</table>
		)//>
	}
	const contentTabelitemmobile = () => {
		if(uHtml500msg) return "";

		return (
		<table className="table table-stripped" id="idtabelitemmobile">
		<thead>
			<tr>
			<th width={25} className="p-0"/>
			<th className="p-0"/>
			</tr>
		</thead>

		<tbody>
		{uItemsArr.map((vItems,vKeys)=>{
			const {
				id_terapi_sub,caption_terapi,tarif_terapi,qty_terapi,diskon_terapi,
				diagnosa_caption,diagnosa_id,diagnosa_keterangan,
				tindakan,keterangan,
				status_ada_garansi,tgl_batas_garansi
			} = vItems;

			return (
			<tr id={"idtr"+vKeys} className="align-top text-end" key={vKeys}>
			<td className="px-1 pe-0">{vKeys+1}.</td>
			<td className="px-1">
				<CRow className="mx-0">
				<CCol xs="12" className="px-1 text-start d-flex justify-content-between align-items-start">
					<div>
						{(keterangan||"")==="" ? (
						<div className="classpetunjuk px-0 text-uppercase">&middot; NOMOR GIGI EMPTY &middot;</div>
						) : (
						<div className="fw-bolder text-uppercase">{keterangan}</div>
						)}
					</div>

					<CDropdown className="ps-1">
					<CDropdownToggle color="transparent" className="p-0" caret={false}>
						<CIcon icon="cilChevronBottom" className="classikonbox align-middle mx-0" height={25}/>
					</CDropdownToggle>

					<CDropdownMenu>
						<CDropdownItem onClick={()=>hdlKlikTabelEditmobile(vKeys)}>
						<CIcon className="me-2 align-middle classikonedit" height={25}/>Edit Data
						</CDropdownItem>

						<CDropdownItem onClick={()=>hdlKlikTabelhapus(vKeys)}>
						<CIcon className="me-2 align-middle classikonhapus" height={25}/>Hapus Terapi
						</CDropdownItem>
					</CDropdownMenu>
					</CDropdown>
				</CCol>

				<CCol xs="12" className="px-1 my-3 classborderbottom"/>

				<CCol xs="12" className="px-1 text-warning text-start">ASSESSMENT</CCol>

				<CCol xs="12" className="px-1 text-start fw-bolder text-end">
					{(diagnosa_caption||"")==="" ? (
					<div className="classpetunjuk px-0">&middot; Diagnosa EMPTY &middot;</div>
					) : (
					<div className="text-primary">{diagnosa_caption}</div>
					)}
				</CCol>

				{(diagnosa_keterangan||"")!=="" && (
				<CCol xs="12" className="px-1 text-end">
					<small className="fst-italic text-capitalize">{diagnosa_keterangan}</small>
				</CCol>
				)}

				<CCol xs="12" className="px-1 my-3 classborderbottom"/>

				<CCol xs="12" className="px-1 text-warning text-start">PLANNING</CCol>

				<CCol xs="12" className="px-1 text-end">
					{(tindakan||"").trim()==="" ? (
					<div className="classpetunjuk px-0">&middot; PLANNING EMPTY &middot;</div>
					) : (
					<small style={{color:"Maroon"}}>{diagnosa_caption}</small>
					)}
				</CCol>

				<CCol xs="12" className="px-1 my-3 classborderbottom"/>

				<CCol xs="12" className="px-1 text-start">
					<>{(caption_terapi||"-")}</>
				</CCol>
				<CCol xs="12" className="px-1 text-end">
					<small>
						<b className="text-primary">{(qty_terapi)}</b>unt
						<span className="mx-1">x</span>
						Rp
						{(parseFloat(diskon_terapi)||0) > 0 ? (
						<>
							(<b className="text-primary">{UFunc.formatAngka(tarif_terapi)}</b>
							<span className="mx-1">-</span>
							<b className="text-danger">{UFunc.formatAngka(diskon_terapi)}</b>
							)
						</>
						) : (
							<b className="text-primary">{UFunc.formatAngka(tarif_terapi)}</b>
						)}
					</small>
				</CCol>

				<CCol xs="12" className="px-1 my-3 classborderbottom"/>

				<CCol xs="4" className="px-1 text-start text-success">
					Nilai (Rp)
				</CCol>
				<CCol xs="8" className="px-1 text-end fw-bolder text-success">
					{UFunc.formatAngka(parseInt(qty_terapi) * 
						(parseFloat(tarif_terapi) - parseFloat(diskon_terapi)))}
				</CCol>
				</CRow>
			</td>
			</tr>
			)//->
		})}
		</tbody>

		{(uItemsArr.length > 0) && (
		<tfoot>
		<tr className="bg-primary text-white fw-bolder">
			<td className="px-1"/>
			<td className="px-1">
			<CRow className="mx-0">
			<CCol xs="6" className="text-start px-1">JUMLAH (Rp)</CCol>
			<CCol xs="6" className="px-1 text-end">{UFunc.formatAngka(uDatamainObj.nilai_bruto)}</CCol>
			</CRow>
			</td>
		</tr>
		<tr className="bg-light classborderbottom d-none">
			<td className="px-1"/>
			<td className="px-1">
			<CRow className="mx-0">
			<CCol className="text-start px-1 text-danger classfontsmaller">
				Diskon &middot; <small>Max:{parseInt(uSystemsettingObj.persen_diskonmax)||0}%</small> (Rp)
			</CCol>
			<CCol xs="6" md="4" className="px-1 text-end">
			<NumberFormat 
				value={uDatamainObj.nilai_diskon||"0"}
				displayType={'text'} 
				thousandSeparator={"."} 
				decimalSeparator={","}
				onValueChange={(values) => uDatamainObj.nilai_diskon=values.value}
				renderText={values => (
					<CFormInput 
						value={values}
						size="sm"
						className="text-end"
						onChange={(e)=>{uDatamainObj.nilai_diskon=e.target.value;setUpdatefield(!uUpdatefield)}}
						onFocus={(e)=>e.target.select()}
					id="inpdiskon"/>
				)} 
			prefix=""/>
			</CCol>
			</CRow>
			</td>
		</tr>
		</tfoot>
		)}
		</table>
		)//->
	}
	const contentNote = () => {
		if(uHtml500msg) return "";

		return (
		<small>
		<CRow className="my-1">
		<CCol xs="4" className="">
			<small className="d-md-none">Catatan Dokter</small>
			<span className="d-none d-md-block">Catatan Dokter</span>
		</CCol>
		<CCol className="text-end">
			<CInputGroup size="sm">
			<CFormInput	size="sm" type="search"
				placeholder={"--"+(uBahasaObj.caption_pilihcatdokter||"Pilih Catatan Dokter")+".."}
				readOnly={true}
				onClick={()=>hdlKlikCatdokterlookup()}
				value={uDatamainObj.note_dokter||""}
				onChange={(e)=>setDatamainObj({...uDatamainObj,note_dokter:e.target.value})}
				id="inpcatdokter"/>
			{(uDatamainObj.note_dokter||"")!=="" && (
			<CButton size="sm" color="light"
				className="text-danger"
				onClick={()=>setDatamainObj({...uDatamainObj,note_dokter:""})}
				id="btncatdokterclear">
				<CIcon icon="cilXCircle"/>
			</CButton>
			)}
			<CButton size="sm" color="dark"
				onClick={()=>hdlKlikCatdokterlookup()}
				id="btncatdokterlookup">
				<CIcon icon="cilMagnifyingGlass"/>
			</CButton>
			</CInputGroup>
		</CCol>
		</CRow>

		<div className="my-3 d-md-none classborderbottom"/>

		<CRow className="my-1">
		<CCol md="4" className="">Cat.Tambahan</CCol>
		<CCol className="text-end">
			<CFormInput	size="sm" maxLength={255}
				value={uDatamainObj.note_nota||""}
				onChange={(e)=>setDatamainObj({...uDatamainObj,note_nota:e.target.value})}
				className="text-capitalize"
				id="inpcatatantambahan"/>
		</CCol>
		</CRow>
		</small>
		)//>
	}
	const contentCatkasir = () => {
		if(uHtml500msg) return "";

		return (
		<>
		<CFormInput size="sm" maxLength={255}
			placeholder="--Catatan Untuk FO"
			value={uDatamainObj.note_kasir || ""}
			onChange={(e)=>{setDatamainObj({...uDatamainObj,note_kasir:e.target.value})}}
			onKeyDown={(e)=>UFunc.hdlKeyDownInput(e,"btnSimpanmain")}
			id="inpcatatankasir"/>

		<div className="my-2 classborderbottom"/>

		<div className="my-1">
			<small className="classpetunjuk">
			&middot; Jadwal reservasi akan disesuaikan dengan data di FO. &middot;
			</small>
		</div>
		</>
		)//>
	}
	const contentPage500 = () => {
		if(!uHtml500msg) return ""

		return (
			<CCard className="my-3 classbgcard">
			<CCardHeader><b>Page 500</b></CCardHeader>
			<CCardBody className="py-5">{UFunc.renderHTML(uHtml500msg)}</CCardBody>
			</CCard>
		)//>
	}
	const contentDlgview = () => {
		if(uHtml500msg) return (<></>);//->
		if(!uIsDlgviewshow) return (<></>);//->

		if(uDlgviewjenis === "PERAWAT")
			return contentDlgviewperawat()
		else if(uDlgviewjenis === "KETGIGI")
			return contentDlgviewketgigi()

		return (<></>)//->
	}
	const contentDlgviewperawat = () => {//--TIDAK_DIPAKAI--/
		if(uDlgviewjenis !== "PERAWAT") return "";

		return (
		<>
		<CRow className="mx-0">
		{uDataperawatArr.map((vItems,vKeys)=>{
			const {
				id,nama_perawat
			} = vItems; 

			return (
			<CCol md="6" lg="4" key={vKeys}>
				<div className="bg-light p-2 py-1 mb-2 border rounded-1">
				<CFormCheck type="checkbox"
					label={nama_perawat}
					value={id}
					checked={UFunc.getObjectIndeks(uPerawatArr,id)>=0}
					onChange={(e)=>{hdlChangePerawatcheck(e)}}
					id={"inpperawat"+id}/>
				</div>
			</CCol>
			) 
		})}
		</CRow>
		</>
		);
	}
	const contentDlgviewketgigi = () => {
		if(uDlgviewjenis !== "KETGIGI") return "";

		return (
		<>
		<table width="100%" cellPadding={3} cellSpacing={0} className="fw-bolder">
			<tbody>
			<tr>
			<td align="left" colSpan={4}><CLink className="classcursorpointer ps-3 d-block bg-light text-decoration-none" style={{color:"Orange"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi Paramolar KW I")}>Paramolar</CLink></td>
			<td align="center" colSpan={4}><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Blue"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi Mesiodent")}>Mesiodent</CLink></td>
			<td className="p-0" rowSpan={9} width={1} bgcolor="Green"><CImage src={pjson.homepage+"api/images/img_spacer.png"} width={1}/></td>
			<td align="center" colSpan={4}><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Blue"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi Mesiodent")}>Mesiodent</CLink></td>
			<td align="right" colSpan={4}><CLink className="classcursorpointer pe-3 d-block bg-light text-decoration-none" style={{color:"Orange"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi Paramolar KW II")}>Paramolar</CLink></td>
			</tr>
			<tr>
			<td align="center" width="7%">&nbsp;</td>
			<td align="center" width="7%">&nbsp;</td>
			<td align="center" width="6%">&nbsp;</td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Maroon"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.55")}>55</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Maroon"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.54")}>54</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Maroon"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.53")}>53</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Maroon"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.52")}>52</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Maroon"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.51")}>51</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Maroon"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.61")}>61</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Maroon"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.62")}>62</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Maroon"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.63")}>63</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Maroon"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.64")}>64</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Maroon"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.65")}>65</CLink></td>
			<td align="center" width="6%">&nbsp;</td>
			<td align="center" width="7%">&nbsp;</td>
			<td align="center" width="7%">&nbsp;</td>
			</tr>
			<tr>
			<td colSpan={8} align="center">&nbsp;</td>
			<td colSpan={8} align="center">&nbsp;</td>
			</tr>
			<tr>
			<td align="center"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.18")}>18</CLink></td>
			<td align="center"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.17")}>17</CLink></td>
			<td align="center"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.16")}>16</CLink></td>
			<td align="center"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.15")}>15</CLink></td>
			<td align="center"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.14")}>14</CLink></td>
			<td align="center"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.13")}>13</CLink></td>
			<td align="center"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.12")}>12</CLink></td>
			<td align="center"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.11")}>11</CLink></td>
			<td align="center"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.21")}>21</CLink></td>
			<td align="center"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.22")}>22</CLink></td>
			<td align="center"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.23")}>23</CLink></td>
			<td align="center"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.24")}>24</CLink></td>
			<td align="center"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.25")}>25</CLink></td>
			<td align="center"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.26")}>26</CLink></td>
			<td align="center"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.27")}>27</CLink></td>
			<td align="center"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.28")}>28</CLink></td>
			</tr>
			<tr height={1}>
			<td colSpan={8} align="center" className="p-0" height={1} style={{fontSize:1,backgroundColor:"green"}}>
				<CImage src={pjson.homepage+"api/images/img_spacer.png"} height={1}/>
			</td>
			<td colSpan={8} align="center" className="p-0" height={1} style={{fontSize:1,backgroundColor:"green"}}>
				<CImage src={pjson.homepage+"api/images/img_spacer.png"} height={1}/>
			</td>
			</tr>
			<tr>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.48")}>48</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.47")}>47</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.46")}>46</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.45")}>45</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.44")}>44</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.43")}>43</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.42")}>42</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.41")}>41</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.31")}>31</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.32")}>32</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.33")}>33</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.34")}>34</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.35")}>35</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.36")}>36</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.37")}>37</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Green"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.38")}>38</CLink></td>
			</tr>
			<tr>
			<td colSpan={8} align="center">&nbsp;</td>
			<td colSpan={8} align="center">&nbsp;</td>
			</tr>
			<tr>
			<td align="center" width="6%">&nbsp;</td>
			<td align="center" width="6%">&nbsp;</td>
			<td align="center" width="6%">&nbsp;</td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Maroon"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.85")}>85</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Maroon"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.84")}>84</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Maroon"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.83")}>83</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Maroon"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.82")}>82</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Maroon"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.81")}>81</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Maroon"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.71")}>71</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Maroon"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.72")}>72</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Maroon"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.73")}>73</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Maroon"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.74")}>74</CLink></td>
			<td align="center" width="6%"><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Maroon"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi No.75")}>75</CLink></td>
			<td align="center" width="6%">&nbsp;</td>
			<td align="center" width="6%">&nbsp;</td>
			<td align="center" width="6%">&nbsp;</td>
			</tr>
			<tr>
			<td align="left" colSpan={4}><CLink className="classcursorpointer ps-3 d-block bg-light text-decoration-none" style={{color:"Orange"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi Paramolar KW IV")}>Paramolar</CLink></td>
			<td align="center" colSpan={4}><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Blue"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi Mesiodent")}>Mesiodent</CLink></td>
			<td align="center" colSpan={4}><CLink className="classcursorpointer d-block bg-light text-decoration-none" style={{color:"Blue"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi Mesiodent")}>Mesiodent</CLink></td>
			<td align="right" colSpan={4}><CLink className="classcursorpointer pe-3 d-block bg-light text-decoration-none" style={{color:"Orange"}} onClick={(e)=> hdlKlikPilihketgigi(e,"Gigi Paramolar KW III")}>Paramolar</CLink></td>
			</tr>
			</tbody>
		</table>
		</>
		)//->
	}
	const contentDlgform = () => {
		if(!uIsDlgformshow) return (<></>)//>

		//if(uDlgformdataObj.jenis === "JANJIAN") return contentFormjanjian();
		if(uDlgformdataObj.jenis === "FORMTERAPI") return contentFormitemmobile();
		return (<></>);//->
	}
	const contentFormitemmobile = () => {
		if(uDlgformdataObj.jenis !== "FORMTERAPI") return (<></>)//>

		const vArridx = uDlgformdataObj.idxtabel===undefined 
			? -1 : parseInt(uDlgformdataObj.idxtabel);

		return (
		<CForm>
		<CRow className="my-2">
			<CCol xs="3" md="4">
				<span className="d-md-none classfontsmaller"><small>Nomor Gigi</small></span>
				<span className="d-none d-md-block">Nomor Gigi</span>
			</CCol>
			<CCol className="text-end">
			{"LAMA" === "TIDAK_DIPAKAI" && (
			<CInputGroup size="sm">
			<CFormInput size="sm" maxLength={255}
				placeholder="--Tuliskan Nomor Gigi.."
				value={uDlgformdataObj.ketgigi||""}
				onChange={(e)=>setDlgformdataObj({...uDlgformdataObj,ketgigi:e.target.value})}
				id="inpformitemketgigi"/>
				{!uISCellphoneview && (
				<CButton size="sm" color="dark"
					className=""
					onClick={()=>hdlKlikKetgigi()}
					id="btnformitemketgigi">
					<CIcon icon="cilSearch"/>
				</CButton>
				)}
			</CInputGroup>
			)}

			{(uDlgformdataObj.ketgigi||"").trim() !== "" ? (
			<div className="d-flex justify-content-between">
				<div className="pe-1 fw-bold">{uDlgformdataObj.ketgigi}</div>

				<div>
				<CLink onClick={async()=>{
					if(await Konfirm("<b>Reset Nomor Gigi</b>.."+
						"<p>Apakah Anda Yakin ?</p>")) { 
						setDlgformdataObj({...uDlgformdataObj,ketgigi:"",odontogram_arr:[]}) 
					} }} 
					className="classcursorpointer">
					<CIcon icon="cilReload" className="classikonbox mx-0 bg-dark border-dark text-white" height={16}/>
				</CLink>

				<CLink onClick={()=>hdlKlikKetgigi()} 
					className="classcursorpointer">
				<CIcon icon="cilPencil" className="classikonbox bg-dark border-dark text-white" height={23}/>
				</CLink>
				</div>
			</div>
			) : (
			<div className="d-grid gap-2">
			<CButton size="sm" color="dark" className=""
				onClick={()=>hdlKlikKetgigi()}
				id="btnformitemketgigi">
				<CIcon icon="cibAddthis" className="me-2 align-middle"/>
				Pilih Nomor Gigi
			</CButton>
			</div>
			)}
			</CCol>
		</CRow>

		<div className="my-3 classborderbottom"/>

		<CRow className="my-2">
			<CCol xs="3" md="4">
				<span className="d-md-none classfontsmaller"><small>Assesment</small></span>
				<span className="d-none d-md-block">Assesment</span>
			</CCol>
			<CCol>
			<CInputGroup size="sm">
			<CFormInput size="sm" maxLength={100}
				readOnly={true}
				value={uDlgformdataObj.diagnosa_caption||""}
				placeholder="--Pilih DIAGNOSA.."
				onClick={()=>hdlKlikFormitemdiagnosalookup()}
				id="inpformitemdiagnosalookup"/>
			<CButton size="sm" color="dark"
				onClick={()=>hdlKlikFormitemdiagnosalookup()}
				id="btnformitemdiagnosalookup">
				<CIcon icon="cilSearch"/>
			</CButton>
			</CInputGroup>
			<CFormInput size="sm" maxLength={255}
				className="mt-2"
				placeholder="--Keterangan Assesment.."
				value={uDlgformdataObj.diagnosa_keterangan||""}
				onChange={(e)=>setDlgformdataObj({...uDlgformdataObj,diagnosa_keterangan:e.target.value})}
				id="inpformitemdiagnosaketerangan"/>
			</CCol>
		</CRow>

		<CRow className="my-2">
			<CCol xs="3" md="4">
				<span className="d-md-none classfontsmaller"><small>PLAN</small></span>
				<span className="d-none d-md-block">Planning</span>
			</CCol>
			<CCol>
			<CFormTextarea size="sm" rows={2}
				className="classfontsmaller py-1"
				value={UFunc.br2nl(uDlgformdataObj.tindakan||"")}
				onChange={(e)=>setDlgformdataObj({...uDlgformdataObj,tindakan:UFunc.nl2br(e.target.value)})}
				placeholder={"--Plan Perawatan Pasien.."}
				id="inpformitemtindakan"/>
			{!isMobile && (
			<div className="classpetunjuk">*) {uBahasaObj.petunjuk_textarea}</div>
			)}
			</CCol>
		</CRow>

		<div className="my-3 classborderbottom"/>

		<CRow className="my-2">
			<CCol xs="3" md="4">
				<span className="d-md-none classfontsmaller"><small>Terapi</small></span>
				<span className="d-none d-md-block">Terapi</span>
			</CCol>

			<CCol>
			<CInputGroup size="sm">
			<CFormInput size="sm"
				readOnly={true}
				value={uDlgformdataObj.terapi_caption||""}
				onClick={() => {
					if(vArridx >= 0) return;
					hdlKlikTerapilookup();
				}}
				placeholder={"--"+(uBahasaObj.caption_keywordterapi||"Masukkan Keyword Terapi").toUpperCase()+".."}
				id="inpformitemcaption"/>
			{vArridx < 0 && (
			<CButton size="sm" color="dark"
				onClick={()=>hdlKlikTerapilookup()}
				id="btnformitemlookup">
				<CIcon icon="cilSearch"/>
			</CButton>
			)}
			</CInputGroup>
			</CCol>
		</CRow>
			
		<CRow className="my-2">
			<CCol xs="3" md="4">
				<span className="d-md-none classfontsmaller"><small>QTY(s)</small></span>
				<span className="d-none d-md-block">QTY(s)</span>
			</CCol>
			<CCol xs="5" md="3" className="">
				<CInputGroup size="sm">
				<CFormInput size="sm" type="number"
					value={uDlgformdataObj.terapi_qty||0}
					onChange={(e)=>setDlgformdataObj({...uDlgformdataObj,terapi_qty:e.target.value})}
					onFocus={(e)=>e.target.select()}
					className="text-end"
					id="inpformitemqty"/>
				<CInputGroupText>unt</CInputGroupText>
				</CInputGroup>
			</CCol>
		</CRow>
			
		<CRow className="my-2 text-danger">
			<CCol xs="3" md="4">
				<span className="d-md-none classfontsmaller"><small>Diskon (Rp)</small></span>
				<span className="d-none d-md-block">Diskon (Rp)</span>
			</CCol>
			<CCol xs="9" md="5" className="">
				<NumberFormat 
					value={uDlgformdataObj.terapi_diskon||"0"}
					displayType={'text'} 
					thousandSeparator={"."} 
					decimalSeparator={","}
					allowNegative={false}
					onValueChange={(values) => uDlgformdataObj.terapi_diskon=values.value}
					renderText={values => (
						<CFormInput 
							value={values}
							size="sm"
							className="text-end text-danger"
							onChange={(e)=>setDlgformdataObj({...uDlgformdataObj,terapi_diskon:e.target.value})}
							onFocus={(e)=>e.target.select()}
							onKeyDown={(e)=>UFunc.hdlKeyDownInput(e,"btnDialogSimpan")}
							id="inpformitemdiskon"/>
					)} 
					prefix={isMobile?"":"Rp"}/>
					<div className="classpetunjuk px-0"><small>(Max:{parseInt(uSystemsettingObj.persen_diskonmax)||100}%)</small></div>
			</CCol>
		</CRow>

		{vArridx >= 0 ? (
		<CRow className="my-2 mt-4 text-success">
			<CCol xs="3" md="4">
				<span className="d-md-none classfontsmaller"><small>Tarif (Rp)</small></span>
				<span className="d-none d-md-block">Tarif Terapi (Rp)</span>
			</CCol>
			<CCol className="text-success fw-bolder">
				{UFunc.formatAngka(
					(parseInt(uDlgformdataObj.terapi_qty)||1) *
						((parseFloat(uDlgformdataObj.terapi_tarif)||0) - 
							(parseFloat(uDlgformdataObj.terapi_diskon)||0))
					)}
			</CCol>
		</CRow>
		) : (
		<CRow className="my-2 mt-4 text-success">
			<CCol xs="3" md="4">
				<span className="d-md-none classfontsmaller"><small>Jml Terapi</small></span>
				<span className="d-none d-md-block">Jml Terapi</span>
			</CCol>
			<CCol className="text-success fw-bolder">
				{(uDlgformdataObj.terapi_arr || []).length} Terapi
			</CCol>
		</CRow>
		)}
		</CForm>
		)//->
	}
	const contentDlgterapi = () => {
		if(!uISDlgterapishow) return "";

		const vDatashowArr		= (uDlgterapiObj.data_arr || []).
			sort((vItemmin, vItemmax) => vItemmax.sort - vItemmin.sort).
			filter((vItems,vKeys)=>{
				if((uDlgterapiObj.kwd_search||"").length < 3) {
					return (vItems.sort > 0 || vKeys < 100);
				}

				return 1
			}).
			filter(vItems=> {
				const vSelectingIdx = UFunc.getObjectIndeks((uDlgterapiObj.selecting_arr||[]),vItems.id);

				return vItems.sort > 0 
					|| vSelectingIdx >= 0
					|| (vItems.caption||"").toUpperCase().
						includes((uDlgterapiObj.kwd_search||"").trim().toUpperCase())
			});

		return (
		<>
		{vDatashowArr.length <= 0 ? (
			<div className="border text-center py-3 py-lg-5 fst-italic">&middot; Data Perawat Tidak Ditemukan &middot;</div>
		) : (
		<CCard>
			<CCardBody className="p-0">
			<div className="d-none">{JSON.stringify(uDlgterapiObj.selecting_arr)}</div>
			<div className="d-none">{uDlgterapiObj.kwd_search}</div>
			<CForm>
			{vDatashowArr.map((vItems,vKeys)=>{

				const vISchecked = (uDlgterapiObj.selecting_arr||[]).filter(vItemselecting=>
					parseInt(vItemselecting.id) === parseInt(vItems.id)
				).length > 0;

				return (
				<div className={"p-2 px-1 px-lg-2"+(vKeys < vDatashowArr.length-1 ? " classborderbottom" : "")}
					key={vKeys}>
				<div className="d-flex justify-content-between">
					<div className="px-0 px-md-1 d-flex align-items-start" style={{minWidth:150,maxWidth:"75%"}}>
						<input type="checkbox" 
							value={vItems.id}
							onChange={(e)=>hdlChangeDlgterapicheck(e)}
							className="mt-2" 
							checked={vISchecked}
							id={"inpchbterapiid"+vItems.id}/>
						<label className="ms-2 classcursorpointer d-block" htmlFor={"inpchbterapiid"+vItems.id}>{vItems.caption}</label>
					</div>

					<div className="px-0 px-md-1 text-end fw-bolder">
					{UFunc.formatAngka(vItems.harga_satuan)}
					</div>
				</div>
				</div>
				)//>
			})}
			</CForm>
			</CCardBody>
		</CCard>
		)}
		</>
		)//>
	}
	//---END CONTENT--/

	//---REST_API--/
	const apiLoadawal = () => {
		setHtml500msg();

		setDatapasienObj({})
		setHeaderloading(true);
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_pasienid : uPasienID,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_periksa/ld_init";

		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			const vTimeEnd = new Date(); const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
			setHeaderloading(false);
			setLoading(false);
			if(output_string.tampil) {
				setDatapasienObj(JSON.parse(output_string.datapasien||"{}"))
				setDatadokterArr(JSON.parse(output_string.datadokter||"[]"))
				//setDataperawatArr(JSON.parse(output_string.dataperawat||"[]"))
				setDataanamnaseArr(JSON.parse(output_string.dataanamnase||"[]"))
				setDatacatdokterArr(JSON.parse(output_string.datanotedokter||"[]"))
				setDataterapiArr(JSON.parse(output_string.dataterapi||"[]"))
				//setDatajanjianArr(JSON.parse(output_string.datajanjian||"[]"))
				setDataitemcicilanArr(JSON.parse(output_string.dataitemcicilan||"[]"))
				setDatadiagnosaArr(JSON.parse(output_string.datadiagnosa||"[]"))

				setDatamainObj({...uDatamainObj,
					progress_id: parseInt(output_string.progress_id || "0"),
					progress_dokterid: parseInt(output_string.progress_dokterid || "0"),
					progress_keterangan: output_string.progress_keterangan || "",
				})
				
				//console.log("(Periksa - apiLoadawal) "+(output_string.datadokter||"[]"))
			} else if(output_string.info) {
				setHtml500msg(output_string.info);
			} else if(output_string.errors) {
				console.log("(Periksa - apiLoadawal) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				setHtml500msg("<div class='text-danger'>"+vMsg+"</div>");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired(); return;
			}

			if(vTimeDiff > 500) setSessionaktif(true);
			else {
				let vTimeout = setTimeout(()=>{ clearTimeout(vTimeout); setSessionaktif(true);},500)
			}
		})
		.catch((error) =>{
			setHeaderloading(false);
			setLoading(false);
			console.log("(Periksa - apiLoadawal) catch-error : "+error);
			setHtml500msg(pjson.mydefault.msg500str.join(" "));
		});
	}
	const apiSimpanmain = () => {
		const vElsimpan	= document.getElementById("btnSimpanmain")
		vElsimpan && (vElsimpan.disabled = true);
		setLoading(true);

		/*let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			vElsimpan && (vElsimpan.disabled = false);
			setLoading(false);
			showToast(uBahasaObj.pesan_periksasukses||"Berhasil","SUKSES");
			//uNavigate(uUrlbefore,{replace:true});
		},2500);return;//-*/

		const vDATAS	= JSON.stringify({
			send_pasienid: uPasienID,
			send_datamain : JSON.stringify(uDatamainObj),
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_periksa/pr_simpanmain";

		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			const vTimeEnd = new Date(); const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
			vElsimpan && (vElsimpan.disabled = false);
			setLoading(false);
			if(output_string.sukses) {
				uDispatch({type: "set", gBillingperiksaObj: undefined});
				showToast((uBahasaObj.pesan_periksasukses||"Berhasil"),"SUKSES");
				uNavigate(uUrlbefore,{replace:true}); return;
			} else if(output_string.periksa_invalid) {
				uDispatch({type: "set", gBillingperiksaObj: undefined});
				showToast(output_string.periksa_invalid);
				uNavigate(uUrlbefore,{replace:true}); return;
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Periksa - apiSimpanmain) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired(); return;
			}

			if(vTimeDiff > 500) setSessionaktif(true);
			else {
				let vTimeout = setTimeout(()=>{ clearTimeout(vTimeout); setSessionaktif(true);},500)
			}
		})
		.catch((error) =>{
			vElsimpan && (vElsimpan.disabled = false);
			setLoading(false);
			console.log("(Rekammedis - apiSimpanmain) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR")
		});
	}
	//---END REST_API--/

	//---EFFECT--/
	React.useEffect(()=>{
		document.addEventListener("keydown",hdlKDownDocument);

		return ()=>{
			document.removeEventListener("keydown",hdlKDownDocument);
		}
	})
	React.useEffect(()=>{
		uDispatch({type: "set", effectApp: !uEfekapp});

    	apiLoadawal();

    	return () => {
			setDlgviewshow(false); setDlgformshow(false); setDlgperawatshow(false);
			setDatadiagnosaArr([]);
    		setDatapasienObj({});
    		setDatadokterArr([]);
    		//setDataperawatArr([]);
    		setDataanamnaseArr([]);
    		setDatacatdokterArr([]);
    		setDatamainObj({});
    		//setDatajanjianArr([]);//-*/
    	}
	},[]);
	React.useEffect(()=>{
		if(uDatamainObj.tgl_periksa===undefined
			) {
			setDatamainObj({...uDatamainObj,
				tgl_periksa: UFunc.DbDate(),
			});
		}
	},[uDatamainObj,uDatamainObj.tgl_periksa])
	React.useEffect(()=>{
		const vDokterid = parseInt(uDatamainObj.progress_dokterid)||0;
		if(vDokterid <= 0 || uDatadokterArr.length <= 0) return;

		const vDokteridx = UFunc.getObjectIndeks(uDatadokterArr,vDokterid);

		setDatamainObj({...uDatamainObj,
			id_dokter: vDokterid,
			nama_dokter: (uDatadokterArr[vDokteridx]||{}).dokter_caption || ""
		});
		//setUpdatefield(!uUpdatefield)
	},[uDatamainObj.progress_dokterid])
	React.useEffect(()=>{
		if(uTokenObj.userhak === "DOKTER") {
			if(uDatamainObj.id_dokter === undefined) {
				setDatamainObj({...uDatamainObj,
					id_dokter: uTokenObj.user_dokterid||"0",
					nama_dokter: uTokenObj.usercaption||"",
				});
			}
			return;
		}
	},[uDatamainObj.id_dokter])
	React.useEffect(()=>{
		if(uItemsArr.length <= 0) {
			setDatamainObj({...uDatamainObj,
				nilai_bruto: undefined,
			});
			//setUpdatefield(!uUpdatefield); 
			return
		}

		const vNilaibruto	= uItemsArr.reduce((vAkumulator, vItems) => 
			vAkumulator + (parseInt(vItems.qty_terapi||0) * (
				parseFloat(vItems.tarif_terapi||0) - parseFloat(vItems.diskon_terapi||0)
			))
		, 0);

		setDatamainObj({...uDatamainObj,
			nilai_bruto: vNilaibruto,
		});
		//setUpdatefield(!uUpdatefield); 
		//console.log("(Periksa - [uItemsArr.length]) uItemsArr => ",uItemsArr)
	},[uItemsArr.length,uTabelitemObj,uIsDlgformshow])
	React.useEffect(()=>{
		if(uTabelitemObj.tabelidx===undefined) return;
			
		const vMaxpersen 	= parseFloat(uSystemsettingObj.persen_diskonmax) || 0;
		const vIdxedit 		= parseInt(uTabelitemObj.tabelidx);

		const vMaxdiskon	= (vMaxpersen <= 0 ? 1 : (vMaxpersen/100)) 
			* (parseInt(uTabelitemObj.tarif_terapi)||0);
		const vDiskon 		= (parseInt(uTabelitemObj.diskon_terapi)||0)
		if(vDiskon > vMaxdiskon) {
			setTabelitemObj({...uTabelitemObj,
				diskon_terapi: vMaxdiskon,
			});
		}
	},[uTabelitemObj,uTabelitemObj.diskon_terapi])
	React.useEffect(()=>{
		if(!uIsDlgformshow) return;
		if(uDlgformdataObj.jenis !== "FORMTERAPI") return;

		const vMaxpersen 	= parseFloat(uSystemsettingObj.persen_diskonmax) || 0;
		const vMaxdiskon	= (vMaxpersen <= 0 ? 1 : (vMaxpersen/100)) * (parseFloat(uDlgformdataObj.terapi_tarif)||0);
		const vDiskon 		= (parseFloat(uDlgformdataObj.terapi_diskon)||0)

		if(vDiskon > vMaxdiskon) {
			setDlgformdataObj({...uDlgformdataObj,
				terapi_diskon: vMaxdiskon,
			});
		}
	},[uDlgformdataObj,uDlgformdataObj.terapi_diskon])
	React.useEffect(()=>{
		if(!uISCellphoneview) {
			setDlgformshow(false);
			setDlgodontogramshow(false);
			return;
		}

		setTabelitemObj({}); setTambahitemObj({});
	},[uISCellphoneview])

	React.useEffect(()=>{
		const vNetto = (parseInt(uDatamainObj.nilai_bruto)||0)
			- (parseInt(uDatamainObj.nilai_diskon)||0)

		uDatamainObj.nilai_netto = vNetto;
		setUpdatefield(!uUpdatefield);
	},[uDatamainObj.nilai_bruto,uDatamainObj.nilai_diskon])
	React.useEffect(()=>{
		if(uDatamainObj.tgl_periksa !== UFunc.DbDate()
			|| (uDatamainObj.anamnase||"").trim() !== ""
			|| (uDatamainObj.note_dokter||"").trim() !== ""
			|| (uDatamainObj.note_nota||"").trim() !== ""
			|| (parseInt(uDatamainObj.id_dokter)||0) !== (parseInt(uTokenObj.user_dokterid)||0)
			|| (parseInt(uDatamainObj.nilai_diskon)||0) > 0
			|| uPerawatArr.length > 0
			|| uItemsArr.length > 0
			|| (uDatamainObj.note_kasir||"").trim() !== ""
			//|| uJanjianArr.length > 0
			//|| uFototambahArr.length > 0
			) setIsFormupdate(true);
		else setIsFormupdate(false);

		uDispatch({type: "set", gBillingperiksaObj: uDatamainObj});
	},[uDatamainObj,
	uDatamainObj.tgl_periksa,
	uDatamainObj.id_dokter,
	uDatamainObj.anamnase,
	uPerawatArr.length,
	uItemsArr.length,
	uDatamainObj.note_dokter,
	uDatamainObj.note_nota,
	uDatamainObj.note_kasir,
	uDatamainObj.nilai_diskon,
	])
	React.useEffect(()=>{
		if(!uIsDlglookupshow) {
			setDlglookupjenis("");
			setInpDlglookup("");
			setDataDlglookupArr([]);
			return;
		}
	},[uIsDlglookupshow])
	React.useEffect(()=>{
		if(!uIsDlgviewshow) {
			setDlgviewheader("");
			setDlgviewjenis("");
			return;
		}
	},[uIsDlgviewshow])
	React.useEffect(()=>{
		if(!uIsDlgformshow) {
			setDlgformheader("")
			setDlgformdataObj({})
			//setCekantrianshow(false)
			return;
		}

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);

			let vElfocus = document.getElementById("inptglantri");
			if(uDlgformdataObj.jenis === "FORMTERAPI")
				vElfocus = document.getElementById("inpformterapicaption");

			if(!isMobile) vElfocus && vElfocus.focus();		
		},350)
	},[uIsDlgformshow]);
	React.useEffect(()=>{
		if(!uISDlgperawatshow) 
			{ setDlgperawatdataObj({}); return }
	},[uISDlgperawatshow]);
	React.useEffect(()=>{
		//console.log("(Periksa - [uISDlgodontogramshow]) uOdontogramprocessingArr => ",uOdontogramprocessingArr)
		if(!uISDlgodontogramshow) { 
			setDlgodontogramdataObj({}); 
			uDispatch({type: "set", gigi_processing_str: undefined});
			return; 
		}
	},[uISDlgodontogramshow]);
	React.useEffect(()=>{
		if(!uISDlgterapishow) {
			setDlgterapiObj({}); return;
		}

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			let vElfocus = document.getElementById("inpdialoglookup");
			if(!isMobile) vElfocus && vElfocus.focus();		
		},350)
	},[uISDlgterapishow]);
	//---END EFFECT--/

	//console.log("(Periksa) uItemsArr => ",uItemsArr)
	if(UFunc.isEmpty(uTokenObj)) { prosesExpired(); return ""; }

	return (
		<>
		<div className="wrapper d-flex flex-column min-vh-100 bg-transparent">
		<CHeader position="sticky" className="mb-3 p-0 m-0">
		<CContainer fluid className="classheadertop m-0" style={{minHeight:64}}>
			<CHeaderToggler className="px-0"
				onClick={() => hdlKlikBack()}>
			<CIcon icon="cilArrowCircleLeft" className="align-middle me-2" height={30}/>
			</CHeaderToggler>
			
			<CHeaderBrand className="me-auto">
				{contentHeadermain()}
			</CHeaderBrand>
			
			<CHeaderNav className="">
				<MyHeaderProfile isWithLogout={false} {...props}/>
			</CHeaderNav>
		</CContainer>

		<CContainer fluid 
			className="bg-white p-2 px-3 justify-content-center justify-content-md-between align-items-center" 
			style={{minHeight:52}}>
			<div style={{width:"60%"}} className="px-2 d-none d-md-block">{contentHeadersub()}</div>

			<div>
			<CTooltip className="d-none d-lg-block" content="--Reset Form Billing">
				<CLink 
					className="classikon classikonreset classcursorpointer"
					onClick={()=>hdlKlikReset()}/>
			</CTooltip>

			{(!uHtml500msg) ? (
			<>
			<span className="mx-1">&middot;</span>
			(<b>{UFunc.formatAngka(uItemsArr.length)}</b>)
			<span className="mx-1">&middot;</span>
			<span className="classfontsmaller"><small className="align-top">Rp</small></span>
			<small className="align-middle text-success fw-bold display-6">
				{UFunc.formatAngka(uDatamainObj.nilai_netto)}
			</small>
			</>
			) : (
				<div className="align-middle text-success fw-bold py-1"/>
			)}
			</div>
		</CContainer>
		</CHeader>

		<div className="body flex-grow-1 px-2 px-lg-5 mb-1">
		<CContainer fluid className="px-0">
		{(uHtml500msg) ? (<>{contentPage500()}</>) : (
		<CForm>
			<div className="d-none">{JSON.stringify(uCabanginitObj)}</div>
			<CRow className="align-items-stretch">
			<CCol md="6" className=" mb-3">
				<CCard className="classbgcard h-100" id="idcardanamnase">
				<CCardHeader className="py-0 pt-1 classfontsmaller">
					<small className="text-muted">Data Periksa</small>
				</CCardHeader>
				
				<CCardBody className="py-2">{contentTanggal()}</CCardBody>
				</CCard>
			</CCol>

			<CCol className="mb-3">
				<CCard className="classbgcard h-100" id="idcardperawat">
				<CCardHeader className="py-0 pt-1 classfontsmaller">
					<small className="text-muted">Data Perawat</small>
				</CCardHeader>

				<CCardBody className="py-2">{contentPerawat()}</CCardBody>
				</CCard>
			</CCol>
			</CRow>

			<CRow className="align-items-stretch">
			<CCol md="6" className="mb-3">
				<CCard className="classbgcard h-100">
				<CCardHeader className="py-0 pt-1 classfontsmaller text-muted">
					<small>Subjective</small>
				</CCardHeader>
				
				<CCardBody className="">{contentSubjective()}</CCardBody>
				</CCard>
			</CCol>

			<CCol md="6" className="mb-3">
				<CCard className="classbgcard h-100">
				<CCardHeader className="py-0 pt-1 classfontsmaller text-muted">
					<small>Objective</small>
				</CCardHeader>
				
				<CCardBody className="">{contentObjective()}</CCardBody>
				</CCard>
			</CCol>
			</CRow>

			<CCard className="classbgcard mb-3">
				<CCardHeader className="py-0 pt-1 text-muted classfontsmaller">
					<small>Assesment & Plan</small>
				</CCardHeader>

				<CCardBody className="px-0">
				<div className="mb-3 py-2 bg-dark">
				{contentTabelform()}
				</div>

				{isMobile ? contentTabelitemmobile() : contentTabelitem()}
				</CCardBody>
			</CCard>

			<CRow className="align-items-stretch">
			<CCol md="6" className="mb-3">
				<CCard className="classbgcard h-100" id="idcardnote">
				<CCardHeader className="py-0 pt-1 classfontsmaller text-muted">
					<small>Catatan Pasien</small>
				</CCardHeader>
				
				<CCardBody className="">{contentNote()}</CCardBody>
				</CCard>
			</CCol>

			<CCol className="mb-3">
				{uTokenObj.userhak === "DOKTER" && (
				<CCard className="classbgcard h-100" id="idcardfooter">
				<CCardHeader className="py-0 pt-1 classfontsmaller text-muted">
					<small>Catatan Front Office</small>
				</CCardHeader>
				
				<CCardBody className="">{contentCatkasir()}</CCardBody>
				</CCard>
				)}
			</CCol>
		</CRow>
		</CForm>
		)}
		</CContainer>
		</div>

		<CFooter position="sticky" className="px-3 text-black-50 justify-content-center" 
			style={{backgroundColor:"#AEAEAE",borderTop:"1px dashed #f0f0f0"}}>
		<MyButton
			onClick={()=>hdlKlikSimpanmain()}
			disabled={uHeaderloading||uHtml500msg||uIsDlgviewshow||uIsDlgformshow||uIsDlglookupshow}
			id="btnSimpanmain">{uBahasaObj.word_simpan||"Simpan"} [F9]</MyButton>
		</CFooter>
		</div>

		<div className="classtooltipcheck text-danger fw-bold" id="iddiagramchecked">
		<CIcon icon="cilCheckCircle" height={20}/>
		</div>

		<MyDialogview
			options={{centered:true,size:(uDlgviewjenis==="KETGIGI"?"xl":"lg")}}
			show={uIsDlgviewshow} 
			dialogHeader={uDlgviewheader}
			toggle={hdlToggleDlgview}
			renderContent={contentDlgview()}/>

		<MyDialoglookup
			show={uIsDlglookupshow}
			toggle={()=>hdlToggleDlgLookup()}
			dialogHeader={uDlglookupheader||"Lookup Data"}
			inputValue={uInpDlglookup}
			dataItemArr={uDataDlglookupArr} 
			onKlikPilihItem={hdlKlikDlglookuppilih}
			id="iddialoglookup"
			{...props}/>

		<MyDialogform
			options={{centered:true,size:uDlgformdataObj.jenis==="FORMPERAWAT"?"lg":"xl"}}
			onSimpan={()=>hdlKlikDlgformsimpan()}
			show={uIsDlgformshow} 
			dialogHeader={uDlgformheader}
			toggle={hdlToggleDlgform}
			renderContent={contentDlgform()}/>

		<MyDialogperawat
			show={uISDlgperawatshow}
			toggle={()=>setDlgperawatshow(false)}
			dataSelectedArr={uDlgperawatdataObj.selected_arr||[]}
			onKlikSimpan={hdlKlikDlgperawatsimpan}
			id="iddialogperawat"
			{...props}/>

		<MyDialogodontogram
			show={uISDlgodontogramshow}
			toggle={()=>setDlgodontogramshow(false)}
			dataSelectedArr={uDlgodontogramdataObj.selected_arr||[]}
			onKlikSimpan={hdlKlikDlgodontogramsimpan}
			id="iddialogodontogram"
			{...props}/>

		<CModal alignment="center"
			size={(uISTabletview||uISCellphoneview) ? "xl" : "lg"}
			className="z-2099"
			visible={uISDlgterapishow}
			scrollable>
			<CModalHeader closeButton className="bg-dark text-light" closeButton={false}>
				<CModalTitle>Pilih: TERAPI</CModalTitle>
				<CCloseButton onClick={()=>setDlgterapishow(false)}/>
			</CModalHeader>
			
			<CModalBody className="p-0" style={{height:window.innerHeight - 175}} id="idmodalbody">
			<div className="sticky-top bg-light p-3 px-lg-5" id="idheaderlookup">
				<CFormInput
					size="sm"
					placeholder="--Masukkan Keyword Terapi"
					autoFocus={true}
					value={uDlgterapiObj.kwd_search||""}
					onChange={(e)=>setDlgterapiObj({...uDlgterapiObj,kwd_search:e.target.value})}
					id="inpdialoglookup"/>
			</div>

			<div className="p-3" id="idrowscroll">
			{contentDlgterapi()}
			</div>
			</CModalBody>

			<CModalFooter>
				<CButton className="px-3" color="dark"
					onClick={()=>hdlKlikDlgterapisimpan()}
					id="btnDlgterapisimpan">
					Simpan
				</CButton>

				<CButton className="px-3" color="light" 
					onClick={()=>setDlgterapishow(false)}
					id="btnDlgterapibatal"> 
				{uBahasaObj.word_batal||"Batal"}
				</CButton>
			</CModalFooter>
		</CModal>

		<MySessionextender active={true} {...props}/>
		</>
	)//->
}	

export default Periksa